// JavaScript Document
const strLink1="https://interior-arne.com/products/"
function setGoods(url,haba,depth,height,color,form){
this.url=url;
this.haba=haba;
this.depth=depth;
this.height=height;
this.color=color;
this.form=form;
}
function searchURL(){
var habaValue=document.getElementById("haba").value;
var depthValue=document.getElementById("depth").value;
var heightValue=document.getElementById("height").value;
var idColor = document.getElementsByName( "colortype" ) ;
for ( colorValue="", i=idColor.length; i--; ) {
 if ( idColor[i].checked ) {
  colorValue = idColor[i].id ;
  break ;
 }
}
if(habaValue=="haba-select" && depthValue=="depth-selected" && heightValue=="height-selected"){
alert("「天板幅・天板奥行・外寸高さ」を選んでください");
return false;
}
if(habaValue=="haba-select" && depthValue=="depth-selected"){
alert("「天板幅・天板奥行」を選んでください");
return false;
}
if(habaValue=="haba-select" && heightValue=="height-selected"){
alert("「天板幅・外寸高さ」を選んでください");
return false;
}
if(depthValue=="depth-selected" && heightValue=="height-selected"){
alert("「天板奥行・外寸高さ」を選んでください");
return false;
}
if(habaValue=="haba-select"){
alert("「天板幅」を選んでください");
return false;
}
if(depthValue=="depth-selected"){
alert("「天板奥行」を選んでください");
return false;
}
if(heightValue=="height-selected"){
alert("「外寸高さ」を選んでください");
return false;
}
if(colorValue==""){
alert("「カラー」を選んでください");
return false;
}
var url=document.getElementById("link_url");
for(var i in goods){
if(goods[i].haba==habaValue && goods[i].depth==depthValue && goods[i].height==heightValue && goods[i].color==colorValue){
return goods[i].url;
}
}
alert("ご希望サイズ幅"+habaValue+"cm×奥行"+depthValue+"cm×高さ"+heightValue+"cmは購入ページのご用意がございません。\nお手数をおかけしますがお見積りを出しますので当店までお問合せくださいませ。");
return false;
}
function jump(){
var idColor = document.getElementsByName( "colortype" ) ;
for ( strColor="", i=idColor.length; i--; ) {
 if ( idColor[i].checked ) {
  strColor = idColor[i].id ;
  var valueColor = idColor[i].value ;
  break ;
 }
}
var url=searchURL();
if(!url){
return false;
}
window.open(strLink1+url)
return false;
}
goods = new Object();
goods[0] =new setGoods("0000a53659","40","30","42","wood","normal");
goods[1] =new setGoods("0000a53664","50","30","42","wood","normal");
goods[2] =new setGoods("0000a53669","60","30","42","wood","normal");
goods[3] =new setGoods("0000a53674","70","30","42","wood","normal");
goods[4] =new setGoods("0000a53679","80","30","42","wood","normal");
goods[5] =new setGoods("0000a53684","90","30","42","wood","normal");
goods[6] =new setGoods("0000a53689","100","30","42","wood","normal");
goods[7] =new setGoods("0000a53694","110","30","42","wood","normal");
goods[8] =new setGoods("0000a53699","120","30","42","wood","normal");
goods[9] =new setGoods("0000a53704","130","30","42","wood","normal");
goods[10] =new setGoods("0000a53709","140","30","42","wood","normal");
goods[11] =new setGoods("0000a53714","150","30","42","wood","normal");
goods[12] =new setGoods("0000a53974","40","40","42","wood","normal");
goods[13] =new setGoods("0000a53719","50","40","42","wood","normal");
goods[14] =new setGoods("0000a53724","60","40","42","wood","normal");
goods[15] =new setGoods("0000a53729","70","40","42","wood","normal");
goods[16] =new setGoods("0000a53734","80","40","42","wood","normal");
goods[17] =new setGoods("0000a53739","90","40","42","wood","normal");
goods[18] =new setGoods("0000a53744","100","40","42","wood","normal");
goods[19] =new setGoods("0000a53749","110","40","42","wood","normal");
goods[20] =new setGoods("0000a53754","120","40","42","wood","normal");
goods[21] =new setGoods("0000a53759","130","40","42","wood","normal");
goods[22] =new setGoods("0000a53764","140","40","42","wood","normal");
goods[23] =new setGoods("0000a53769","150","40","42","wood","normal");
goods[24] =new setGoods("0000a53979","50","50","42","wood","normal");
goods[25] =new setGoods("0000a53774","60","50","42","wood","normal");
goods[26] =new setGoods("0000a53779","70","50","42","wood","normal");
goods[27] =new setGoods("0000a53784","80","50","42","wood","normal");
goods[28] =new setGoods("0000a53789","90","50","42","wood","normal");
goods[29] =new setGoods("0000a53794","100","50","42","wood","normal");
goods[30] =new setGoods("0000a53799","110","50","42","wood","normal");
goods[31] =new setGoods("0000a53804","120","50","42","wood","normal");
goods[32] =new setGoods("0000a53809","130","50","42","wood","normal");
goods[33] =new setGoods("0000a53814","140","50","42","wood","normal");
goods[34] =new setGoods("0000a53819","150","50","42","wood","normal");
goods[35] =new setGoods("0000a53984","60","60","42","wood","normal");
goods[36] =new setGoods("0000a53824","70","60","42","wood","normal");
goods[37] =new setGoods("0000a53829","80","60","42","wood","normal");
goods[38] =new setGoods("0000a53834","90","60","42","wood","normal");
goods[39] =new setGoods("0000a53839","100","60","42","wood","normal");
goods[40] =new setGoods("0000a53844","110","60","42","wood","normal");
goods[41] =new setGoods("0000a53849","120","60","42","wood","normal");
goods[42] =new setGoods("0000a53854","130","60","42","wood","normal");
goods[43] =new setGoods("0000a53859","140","60","42","wood","normal");
goods[44] =new setGoods("0000a53864","150","60","42","wood","normal");
goods[45] =new setGoods("0000a53989","70","70","42","wood","normal");
goods[46] =new setGoods("0000a53869","80","70","42","wood","normal");
goods[47] =new setGoods("0000a53874","90","70","42","wood","normal");
goods[48] =new setGoods("0000a53879","100","70","42","wood","normal");
goods[49] =new setGoods("0000a53884","110","70","42","wood","normal");
goods[50] =new setGoods("0000a53889","120","70","42","wood","normal");
goods[51] =new setGoods("0000a53894","130","70","42","wood","normal");
goods[52] =new setGoods("0000a53899","140","70","42","wood","normal");
goods[53] =new setGoods("0000a53904","150","70","42","wood","normal");
goods[54] =new setGoods("0000a53994","80","80","42","wood","normal");
goods[55] =new setGoods("0000a53909","90","80","42","wood","normal");
goods[56] =new setGoods("0000a53914","100","80","42","wood","normal");
goods[57] =new setGoods("0000a53919","110","80","42","wood","normal");
goods[58] =new setGoods("0000a53924","120","80","42","wood","normal");
goods[59] =new setGoods("0000a53929","130","80","42","wood","normal");
goods[60] =new setGoods("0000a53934","140","80","42","wood","normal");
goods[61] =new setGoods("0000a53939","150","80","42","wood","normal");
goods[62] =new setGoods("0000a53999","90","90","42","wood","normal");
goods[63] =new setGoods("0000a53944","100","90","42","wood","normal");
goods[64] =new setGoods("0000a53949","110","90","42","wood","normal");
goods[65] =new setGoods("0000a53954","120","90","42","wood","normal");
goods[66] =new setGoods("0000a53959","130","90","42","wood","normal");
goods[67] =new setGoods("0000a53964","140","90","42","wood","normal");
goods[68] =new setGoods("0000a53969","150","90","42","wood","normal");
goods[69] =new setGoods("0000a54004","40","30","60","wood","normal");
goods[70] =new setGoods("0000a54009","50","30","60","wood","normal");
goods[71] =new setGoods("0000a54014","60","30","60","wood","normal");
goods[72] =new setGoods("0000a54019","70","30","60","wood","normal");
goods[73] =new setGoods("0000a54024","80","30","60","wood","normal");
goods[74] =new setGoods("0000a54029","90","30","60","wood","normal");
goods[75] =new setGoods("0000a54034","100","30","60","wood","normal");
goods[76] =new setGoods("0000a54039","110","30","60","wood","normal");
goods[77] =new setGoods("0000a54044","120","30","60","wood","normal");
goods[78] =new setGoods("0000a54049","130","30","60","wood","normal");
goods[79] =new setGoods("0000a54054","140","30","60","wood","normal");
goods[80] =new setGoods("0000a54059","150","30","60","wood","normal");
goods[81] =new setGoods("0000a54319","40","40","60","wood","normal");
goods[82] =new setGoods("0000a54064","50","40","60","wood","normal");
goods[83] =new setGoods("0000a54069","60","40","60","wood","normal");
goods[84] =new setGoods("0000a54074","70","40","60","wood","normal");
goods[85] =new setGoods("0000a54079","80","40","60","wood","normal");
goods[86] =new setGoods("0000a54084","90","40","60","wood","normal");
goods[87] =new setGoods("0000a54089","100","40","60","wood","normal");
goods[88] =new setGoods("0000a54094","110","40","60","wood","normal");
goods[89] =new setGoods("0000a54099","120","40","60","wood","normal");
goods[90] =new setGoods("0000a54104","130","40","60","wood","normal");
goods[91] =new setGoods("0000a54109","140","40","60","wood","normal");
goods[92] =new setGoods("0000a54114","150","40","60","wood","normal");
goods[93] =new setGoods("0000a54324","50","50","60","wood","normal");
goods[94] =new setGoods("0000a54119","60","50","60","wood","normal");
goods[95] =new setGoods("0000a54124","70","50","60","wood","normal");
goods[96] =new setGoods("0000a54129","80","50","60","wood","normal");
goods[97] =new setGoods("0000a54134","90","50","60","wood","normal");
goods[98] =new setGoods("0000a54139","100","50","60","wood","normal");
goods[99] =new setGoods("0000a54144","110","50","60","wood","normal");
goods[100] =new setGoods("0000a54149","120","50","60","wood","normal");
goods[101] =new setGoods("0000a54154","130","50","60","wood","normal");
goods[102] =new setGoods("0000a54159","140","50","60","wood","normal");
goods[103] =new setGoods("0000a54164","150","50","60","wood","normal");
goods[104] =new setGoods("0000a54329","60","60","60","wood","normal");
goods[105] =new setGoods("0000a54169","70","60","60","wood","normal");
goods[106] =new setGoods("0000a54174","80","60","60","wood","normal");
goods[107] =new setGoods("0000a54179","90","60","60","wood","normal");
goods[108] =new setGoods("0000a54184","100","60","60","wood","normal");
goods[109] =new setGoods("0000a54189","110","60","60","wood","normal");
goods[110] =new setGoods("0000a54194","120","60","60","wood","normal");
goods[111] =new setGoods("0000a54199","130","60","60","wood","normal");
goods[112] =new setGoods("0000a54204","140","60","60","wood","normal");
goods[113] =new setGoods("0000a54209","150","60","60","wood","normal");
goods[114] =new setGoods("0000a54334","70","70","60","wood","normal");
goods[115] =new setGoods("0000a54214","80","70","60","wood","normal");
goods[116] =new setGoods("0000a54219","90","70","60","wood","normal");
goods[117] =new setGoods("0000a54224","100","70","60","wood","normal");
goods[118] =new setGoods("0000a54229","110","70","60","wood","normal");
goods[119] =new setGoods("0000a54234","120","70","60","wood","normal");
goods[120] =new setGoods("0000a54239","130","70","60","wood","normal");
goods[121] =new setGoods("0000a54244","140","70","60","wood","normal");
goods[122] =new setGoods("0000a54249","150","70","60","wood","normal");
goods[123] =new setGoods("0000a54339","80","80","60","wood","normal");
goods[124] =new setGoods("0000a54254","90","80","60","wood","normal");
goods[125] =new setGoods("0000a54259","100","80","60","wood","normal");
goods[126] =new setGoods("0000a54264","110","80","60","wood","normal");
goods[127] =new setGoods("0000a54269","120","80","60","wood","normal");
goods[128] =new setGoods("0000a54274","130","80","60","wood","normal");
goods[129] =new setGoods("0000a54279","140","80","60","wood","normal");
goods[130] =new setGoods("0000a54284","150","80","60","wood","normal");
goods[131] =new setGoods("0000a54344","90","90","60","wood","normal");
goods[132] =new setGoods("0000a54289","100","90","60","wood","normal");
goods[133] =new setGoods("0000a54294","110","90","60","wood","normal");
goods[134] =new setGoods("0000a54299","120","90","60","wood","normal");
goods[135] =new setGoods("0000a54304","130","90","60","wood","normal");
goods[136] =new setGoods("0000a54309","140","90","60","wood","normal");
goods[137] =new setGoods("0000a54314","150","90","60","wood","normal");
goods[138] =new setGoods("0000a54349","40","30","72","wood","normal");
goods[139] =new setGoods("0000a54354","50","30","72","wood","normal");
goods[140] =new setGoods("0000a54359","60","30","72","wood","normal");
goods[141] =new setGoods("0000a54364","70","30","72","wood","normal");
goods[142] =new setGoods("0000a54369","80","30","72","wood","normal");
goods[143] =new setGoods("0000a54374","90","30","72","wood","normal");
goods[144] =new setGoods("0000a54379","100","30","72","wood","normal");
goods[145] =new setGoods("0000a54384","110","30","72","wood","normal");
goods[146] =new setGoods("0000a54389","120","30","72","wood","normal");
goods[147] =new setGoods("0000a54394","130","30","72","wood","normal");
goods[148] =new setGoods("0000a54399","140","30","72","wood","normal");
goods[149] =new setGoods("0000a54404","150","30","72","wood","normal");
goods[150] =new setGoods("0000a54664","40","40","72","wood","normal");
goods[151] =new setGoods("0000a54409","50","40","72","wood","normal");
goods[152] =new setGoods("0000a54414","60","40","72","wood","normal");
goods[153] =new setGoods("0000a54419","70","40","72","wood","normal");
goods[154] =new setGoods("0000a54424","80","40","72","wood","normal");
goods[155] =new setGoods("0000a54429","90","40","72","wood","normal");
goods[156] =new setGoods("0000a54434","100","40","72","wood","normal");
goods[157] =new setGoods("0000a54439","110","40","72","wood","normal");
goods[158] =new setGoods("0000a54444","120","40","72","wood","normal");
goods[159] =new setGoods("0000a54449","130","40","72","wood","normal");
goods[160] =new setGoods("0000a54454","140","40","72","wood","normal");
goods[161] =new setGoods("0000a54459","150","40","72","wood","normal");
goods[162] =new setGoods("0000a54669","50","50","72","wood","normal");
goods[163] =new setGoods("0000a54464","60","50","72","wood","normal");
goods[164] =new setGoods("0000a54469","70","50","72","wood","normal");
goods[165] =new setGoods("0000a54474","80","50","72","wood","normal");
goods[166] =new setGoods("0000a54479","90","50","72","wood","normal");
goods[167] =new setGoods("0000a54484","100","50","72","wood","normal");
goods[168] =new setGoods("0000a54489","110","50","72","wood","normal");
goods[169] =new setGoods("0000a54494","120","50","72","wood","normal");
goods[170] =new setGoods("0000a54499","130","50","72","wood","normal");
goods[171] =new setGoods("0000a54504","140","50","72","wood","normal");
goods[172] =new setGoods("0000a54509","150","50","72","wood","normal");
goods[173] =new setGoods("0000a54674","60","60","72","wood","normal");
goods[174] =new setGoods("0000a54514","70","60","72","wood","normal");
goods[175] =new setGoods("0000a54519","80","60","72","wood","normal");
goods[176] =new setGoods("0000a54524","90","60","72","wood","normal");
goods[177] =new setGoods("0000a54529","100","60","72","wood","normal");
goods[178] =new setGoods("0000a54534","110","60","72","wood","normal");
goods[179] =new setGoods("0000a54539","120","60","72","wood","normal");
goods[180] =new setGoods("0000a54544","130","60","72","wood","normal");
goods[181] =new setGoods("0000a54549","140","60","72","wood","normal");
goods[182] =new setGoods("0000a54554","150","60","72","wood","normal");
goods[183] =new setGoods("0000a54679","70","70","72","wood","normal");
goods[184] =new setGoods("0000a54559","80","70","72","wood","normal");
goods[185] =new setGoods("0000a54564","90","70","72","wood","normal");
goods[186] =new setGoods("0000a54569","100","70","72","wood","normal");
goods[187] =new setGoods("0000a54574","110","70","72","wood","normal");
goods[188] =new setGoods("0000a54579","120","70","72","wood","normal");
goods[189] =new setGoods("0000a54584","130","70","72","wood","normal");
goods[190] =new setGoods("0000a54589","140","70","72","wood","normal");
goods[191] =new setGoods("0000a54594","150","70","72","wood","normal");
goods[192] =new setGoods("0000a54684","80","80","72","wood","normal");
goods[193] =new setGoods("0000a54599","90","80","72","wood","normal");
goods[194] =new setGoods("0000a54604","100","80","72","wood","normal");
goods[195] =new setGoods("0000a54609","110","80","72","wood","normal");
goods[196] =new setGoods("0000a54614","120","80","72","wood","normal");
goods[197] =new setGoods("0000a54619","130","80","72","wood","normal");
goods[198] =new setGoods("0000a54624","140","80","72","wood","normal");
goods[199] =new setGoods("0000a54629","150","80","72","wood","normal");
goods[200] =new setGoods("0000a54689","90","90","72","wood","normal");
goods[201] =new setGoods("0000a54634","100","90","72","wood","normal");
goods[202] =new setGoods("0000a54639","110","90","72","wood","normal");
goods[203] =new setGoods("0000a54644","120","90","72","wood","normal");
goods[204] =new setGoods("0000a54649","130","90","72","wood","normal");
goods[205] =new setGoods("0000a54654","140","90","72","wood","normal");
goods[206] =new setGoods("0000a54659","150","90","72","wood","normal");
goods[207] =new setGoods("0000a54949","40","40","90","wood","normal");
goods[208] =new setGoods("0000a54694","50","40","90","wood","normal");
goods[209] =new setGoods("0000a54699","60","40","90","wood","normal");
goods[210] =new setGoods("0000a54704","70","40","90","wood","normal");
goods[211] =new setGoods("0000a54709","80","40","90","wood","normal");
goods[212] =new setGoods("0000a54714","90","40","90","wood","normal");
goods[213] =new setGoods("0000a54719","100","40","90","wood","normal");
goods[214] =new setGoods("0000a54724","110","40","90","wood","normal");
goods[215] =new setGoods("0000a54729","120","40","90","wood","normal");
goods[216] =new setGoods("0000a54734","130","40","90","wood","normal");
goods[217] =new setGoods("0000a54739","140","40","90","wood","normal");
goods[218] =new setGoods("0000a54744","150","40","90","wood","normal");
goods[219] =new setGoods("0000a54954","50","50","90","wood","normal");
goods[220] =new setGoods("0000a54749","60","50","90","wood","normal");
goods[221] =new setGoods("0000a54754","70","50","90","wood","normal");
goods[222] =new setGoods("0000a54759","80","50","90","wood","normal");
goods[223] =new setGoods("0000a54764","90","50","90","wood","normal");
goods[224] =new setGoods("0000a54769","100","50","90","wood","normal");
goods[225] =new setGoods("0000a54774","110","50","90","wood","normal");
goods[226] =new setGoods("0000a54779","120","50","90","wood","normal");
goods[227] =new setGoods("0000a54784","130","50","90","wood","normal");
goods[228] =new setGoods("0000a54789","140","50","90","wood","normal");
goods[229] =new setGoods("0000a54794","150","50","90","wood","normal");
goods[230] =new setGoods("0000a54959","60","60","90","wood","normal");
goods[231] =new setGoods("0000a54799","70","60","90","wood","normal");
goods[232] =new setGoods("0000a54804","80","60","90","wood","normal");
goods[233] =new setGoods("0000a54809","90","60","90","wood","normal");
goods[234] =new setGoods("0000a54814","100","60","90","wood","normal");
goods[235] =new setGoods("0000a54819","110","60","90","wood","normal");
goods[236] =new setGoods("0000a54824","120","60","90","wood","normal");
goods[237] =new setGoods("0000a54829","130","60","90","wood","normal");
goods[238] =new setGoods("0000a54834","140","60","90","wood","normal");
goods[239] =new setGoods("0000a54839","150","60","90","wood","normal");
goods[240] =new setGoods("0000a54964","70","70","90","wood","normal");
goods[241] =new setGoods("0000a54844","80","70","90","wood","normal");
goods[242] =new setGoods("0000a54849","90","70","90","wood","normal");
goods[243] =new setGoods("0000a54854","100","70","90","wood","normal");
goods[244] =new setGoods("0000a54859","110","70","90","wood","normal");
goods[245] =new setGoods("0000a54864","120","70","90","wood","normal");
goods[246] =new setGoods("0000a54869","130","70","90","wood","normal");
goods[247] =new setGoods("0000a54874","140","70","90","wood","normal");
goods[248] =new setGoods("0000a54879","150","70","90","wood","normal");
goods[249] =new setGoods("0000a54969","80","80","90","wood","normal");
goods[250] =new setGoods("0000a54884","90","80","90","wood","normal");
goods[251] =new setGoods("0000a54889","100","80","90","wood","normal");
goods[252] =new setGoods("0000a54894","110","80","90","wood","normal");
goods[253] =new setGoods("0000a54899","120","80","90","wood","normal");
goods[254] =new setGoods("0000a54904","130","80","90","wood","normal");
goods[255] =new setGoods("0000a54909","140","80","90","wood","normal");
goods[256] =new setGoods("0000a54914","150","80","90","wood","normal");
goods[257] =new setGoods("0000a54974","90","90","90","wood","normal");
goods[258] =new setGoods("0000a54919","100","90","90","wood","normal");
goods[259] =new setGoods("0000a54924","110","90","90","wood","normal");
goods[260] =new setGoods("0000a54929","120","90","90","wood","normal");
goods[261] =new setGoods("0000a54934","130","90","90","wood","normal");
goods[262] =new setGoods("0000a54939","140","90","90","wood","normal");
goods[263] =new setGoods("0000a54944","150","90","90","wood","normal");



goods[264] =new setGoods("0000a57524","40","30","42","nail","normal");
goods[265] =new setGoods("0000a57525","50","30","42","nail","normal");
goods[266] =new setGoods("0000a57526","60","30","42","nail","normal");
goods[267] =new setGoods("0000a57527","70","30","42","nail","normal");
goods[268] =new setGoods("0000a57528","80","30","42","nail","normal");
goods[269] =new setGoods("0000a57529","90","30","42","nail","normal");
goods[270] =new setGoods("0000a57530","100","30","42","nail","normal");
goods[271] =new setGoods("0000a57531","110","30","42","nail","normal");
goods[272] =new setGoods("0000a57532","120","30","42","nail","normal");
goods[273] =new setGoods("0000a57533","130","30","42","nail","normal");
goods[274] =new setGoods("0000a57534","140","30","42","nail","normal");
goods[275] =new setGoods("0000a57535","150","30","42","nail","normal");
goods[276] =new setGoods("0000a57536","50","40","42","nail","normal");
goods[277] =new setGoods("0000a57537","60","40","42","nail","normal");
goods[278] =new setGoods("0000a57538","70","40","42","nail","normal");
goods[279] =new setGoods("0000a57539","80","40","42","nail","normal");
goods[280] =new setGoods("0000a57540","90","40","42","nail","normal");
goods[281] =new setGoods("0000a57541","100","40","42","nail","normal");
goods[282] =new setGoods("0000a57542","110","40","42","nail","normal");
goods[283] =new setGoods("0000a57543","120","40","42","nail","normal");
goods[284] =new setGoods("0000a57544","130","40","42","nail","normal");
goods[285] =new setGoods("0000a57545","140","40","42","nail","normal");
goods[286] =new setGoods("0000a57546","150","40","42","nail","normal");
goods[287] =new setGoods("0000a57547","60","50","42","nail","normal");
goods[288] =new setGoods("0000a57548","70","50","42","nail","normal");
goods[289] =new setGoods("0000a57549","80","50","42","nail","normal");
goods[290] =new setGoods("0000a57550","90","50","42","nail","normal");
goods[291] =new setGoods("0000a57551","100","50","42","nail","normal");
goods[292] =new setGoods("0000a57552","110","50","42","nail","normal");
goods[293] =new setGoods("0000a57553","120","50","42","nail","normal");
goods[294] =new setGoods("0000a57554","130","50","42","nail","normal");
goods[295] =new setGoods("0000a57555","140","50","42","nail","normal");
goods[296] =new setGoods("0000a57556","150","50","42","nail","normal");
goods[297] =new setGoods("0000a57557","70","60","42","nail","normal");
goods[298] =new setGoods("0000a57558","80","60","42","nail","normal");
goods[299] =new setGoods("0000a57559","90","60","42","nail","normal");
goods[300] =new setGoods("0000a57560","100","60","42","nail","normal");
goods[301] =new setGoods("0000a57561","110","60","42","nail","normal");
goods[302] =new setGoods("0000a57562","120","60","42","nail","normal");
goods[303] =new setGoods("0000a57563","130","60","42","nail","normal");
goods[304] =new setGoods("0000a57564","140","60","42","nail","normal");
goods[305] =new setGoods("0000a57565","150","60","42","nail","normal");
goods[306] =new setGoods("0000a57566","80","70","42","nail","normal");
goods[307] =new setGoods("0000a57567","90","70","42","nail","normal");
goods[308] =new setGoods("0000a57568","100","70","42","nail","normal");
goods[309] =new setGoods("0000a57569","110","70","42","nail","normal");
goods[310] =new setGoods("0000a57570","120","70","42","nail","normal");
goods[311] =new setGoods("0000a57571","130","70","42","nail","normal");
goods[312] =new setGoods("0000a57572","140","70","42","nail","normal");
goods[313] =new setGoods("0000a57573","150","70","42","nail","normal");
goods[314] =new setGoods("0000a57574","90","80","42","nail","normal");
goods[315] =new setGoods("0000a57575","100","80","42","nail","normal");
goods[316] =new setGoods("0000a57576","110","80","42","nail","normal");
goods[317] =new setGoods("0000a57577","120","80","42","nail","normal");
goods[318] =new setGoods("0000a57578","130","80","42","nail","normal");
goods[319] =new setGoods("0000a57579","140","80","42","nail","normal");
goods[320] =new setGoods("0000a57580","150","80","42","nail","normal");
goods[321] =new setGoods("0000a57581","100","90","42","nail","normal");
goods[322] =new setGoods("0000a57582","110","90","42","nail","normal");
goods[323] =new setGoods("0000a57583","120","90","42","nail","normal");
goods[324] =new setGoods("0000a57584","130","90","42","nail","normal");
goods[325] =new setGoods("0000a57585","140","90","42","nail","normal");
goods[326] =new setGoods("0000a57586","150","90","42","nail","normal");
goods[327] =new setGoods("0000a57587","40","40","42","nail","normal");
goods[328] =new setGoods("0000a57588","50","50","42","nail","normal");
goods[329] =new setGoods("0000a57589","60","60","42","nail","normal");
goods[330] =new setGoods("0000a57590","70","70","42","nail","normal");
goods[331] =new setGoods("0000a57591","80","80","42","nail","normal");
goods[332] =new setGoods("0000a57592","90","90","42","nail","normal");
goods[333] =new setGoods("0000a57593","40","30","60","nail","normal");
goods[334] =new setGoods("0000a57594","50","30","60","nail","normal");
goods[335] =new setGoods("0000a57595","60","30","60","nail","normal");
goods[336] =new setGoods("0000a57596","70","30","60","nail","normal");
goods[337] =new setGoods("0000a57597","80","30","60","nail","normal");
goods[338] =new setGoods("0000a57598","90","30","60","nail","normal");
goods[339] =new setGoods("0000a57599","100","30","60","nail","normal");
goods[340] =new setGoods("0000a57600","110","30","60","nail","normal");
goods[341] =new setGoods("0000a57601","120","30","60","nail","normal");
goods[342] =new setGoods("0000a57602","130","30","60","nail","normal");
goods[343] =new setGoods("0000a57603","140","30","60","nail","normal");
goods[344] =new setGoods("0000a57604","150","30","60","nail","normal");
goods[345] =new setGoods("0000a57605","50","40","60","nail","normal");
goods[346] =new setGoods("0000a57606","60","40","60","nail","normal");
goods[347] =new setGoods("0000a57607","70","40","60","nail","normal");
goods[348] =new setGoods("0000a57608","80","40","60","nail","normal");
goods[349] =new setGoods("0000a57609","90","40","60","nail","normal");
goods[350] =new setGoods("0000a57610","100","40","60","nail","normal");
goods[351] =new setGoods("0000a57611","110","40","60","nail","normal");
goods[352] =new setGoods("0000a57612","120","40","60","nail","normal");
goods[353] =new setGoods("0000a57613","130","40","60","nail","normal");
goods[354] =new setGoods("0000a57614","140","40","60","nail","normal");
goods[355] =new setGoods("0000a57615","150","40","60","nail","normal");
goods[356] =new setGoods("0000a57616","60","50","60","nail","normal");
goods[357] =new setGoods("0000a57617","70","50","60","nail","normal");
goods[358] =new setGoods("0000a57618","80","50","60","nail","normal");
goods[359] =new setGoods("0000a57619","90","50","60","nail","normal");
goods[360] =new setGoods("0000a57620","100","50","60","nail","normal");
goods[361] =new setGoods("0000a57621","110","50","60","nail","normal");
goods[362] =new setGoods("0000a57622","120","50","60","nail","normal");
goods[363] =new setGoods("0000a57623","130","50","60","nail","normal");
goods[364] =new setGoods("0000a57624","140","50","60","nail","normal");
goods[365] =new setGoods("0000a57625","150","50","60","nail","normal");
goods[366] =new setGoods("0000a57626","70","60","60","nail","normal");
goods[367] =new setGoods("0000a57627","80","60","60","nail","normal");
goods[368] =new setGoods("0000a57628","90","60","60","nail","normal");
goods[369] =new setGoods("0000a57629","100","60","60","nail","normal");
goods[370] =new setGoods("0000a57630","110","60","60","nail","normal");
goods[371] =new setGoods("0000a57631","120","60","60","nail","normal");
goods[372] =new setGoods("0000a57632","130","60","60","nail","normal");
goods[373] =new setGoods("0000a57633","140","60","60","nail","normal");
goods[374] =new setGoods("0000a57634","150","60","60","nail","normal");
goods[375] =new setGoods("0000a57635","80","70","60","nail","normal");
goods[376] =new setGoods("0000a57636","90","70","60","nail","normal");
goods[377] =new setGoods("0000a57637","100","70","60","nail","normal");
goods[378] =new setGoods("0000a57638","110","70","60","nail","normal");
goods[379] =new setGoods("0000a57639","120","70","60","nail","normal");
goods[380] =new setGoods("0000a57640","130","70","60","nail","normal");
goods[381] =new setGoods("0000a57641","140","70","60","nail","normal");
goods[382] =new setGoods("0000a57642","150","70","60","nail","normal");
goods[383] =new setGoods("0000a57643","90","80","60","nail","normal");
goods[384] =new setGoods("0000a57644","100","80","60","nail","normal");
goods[385] =new setGoods("0000a57645","110","80","60","nail","normal");
goods[386] =new setGoods("0000a57646","120","80","60","nail","normal");
goods[387] =new setGoods("0000a57647","130","80","60","nail","normal");
goods[388] =new setGoods("0000a57648","140","80","60","nail","normal");
goods[389] =new setGoods("0000a57649","150","80","60","nail","normal");
goods[390] =new setGoods("0000a57650","100","90","60","nail","normal");
goods[391] =new setGoods("0000a57651","110","90","60","nail","normal");
goods[392] =new setGoods("0000a57652","120","90","60","nail","normal");
goods[393] =new setGoods("0000a57653","130","90","60","nail","normal");
goods[394] =new setGoods("0000a57654","140","90","60","nail","normal");
goods[395] =new setGoods("0000a57655","150","90","60","nail","normal");
goods[396] =new setGoods("0000a57656","40","40","60","nail","normal");
goods[397] =new setGoods("0000a57657","50","50","60","nail","normal");
goods[398] =new setGoods("0000a57658","60","60","60","nail","normal");
goods[399] =new setGoods("0000a57659","70","70","60","nail","normal");
goods[400] =new setGoods("0000a57660","80","80","60","nail","normal");
goods[401] =new setGoods("0000a57661","90","90","60","nail","normal");
goods[402] =new setGoods("0000a57662","40","30","72","nail","normal");
goods[403] =new setGoods("0000a57663","50","30","72","nail","normal");
goods[404] =new setGoods("0000a57664","60","30","72","nail","normal");
goods[405] =new setGoods("0000a57665","70","30","72","nail","normal");
goods[406] =new setGoods("0000a57666","80","30","72","nail","normal");
goods[407] =new setGoods("0000a57667","90","30","72","nail","normal");
goods[408] =new setGoods("0000a57668","100","30","72","nail","normal");
goods[409] =new setGoods("0000a57669","110","30","72","nail","normal");
goods[410] =new setGoods("0000a57670","120","30","72","nail","normal");
goods[411] =new setGoods("0000a57671","130","30","72","nail","normal");
goods[412] =new setGoods("0000a57672","140","30","72","nail","normal");
goods[413] =new setGoods("0000a57673","150","30","72","nail","normal");
goods[414] =new setGoods("0000a57674","50","40","72","nail","normal");
goods[415] =new setGoods("0000a57675","60","40","72","nail","normal");
goods[416] =new setGoods("0000a57676","70","40","72","nail","normal");
goods[417] =new setGoods("0000a57677","80","40","72","nail","normal");
goods[418] =new setGoods("0000a57678","90","40","72","nail","normal");
goods[419] =new setGoods("0000a57679","100","40","72","nail","normal");
goods[420] =new setGoods("0000a57680","110","40","72","nail","normal");
goods[421] =new setGoods("0000a57681","120","40","72","nail","normal");
goods[422] =new setGoods("0000a57682","130","40","72","nail","normal");
goods[423] =new setGoods("0000a57683","140","40","72","nail","normal");
goods[424] =new setGoods("0000a57684","150","40","72","nail","normal");
goods[425] =new setGoods("0000a57685","60","50","72","nail","normal");
goods[426] =new setGoods("0000a57686","70","50","72","nail","normal");
goods[427] =new setGoods("0000a57687","80","50","72","nail","normal");
goods[428] =new setGoods("0000a57688","90","50","72","nail","normal");
goods[429] =new setGoods("0000a57689","100","50","72","nail","normal");
goods[430] =new setGoods("0000a57690","110","50","72","nail","normal");
goods[431] =new setGoods("0000a57691","120","50","72","nail","normal");
goods[432] =new setGoods("0000a57692","130","50","72","nail","normal");
goods[433] =new setGoods("0000a57693","140","50","72","nail","normal");
goods[434] =new setGoods("0000a57694","150","50","72","nail","normal");
goods[435] =new setGoods("0000a57695","70","60","72","nail","normal");
goods[436] =new setGoods("0000a57696","80","60","72","nail","normal");
goods[437] =new setGoods("0000a57697","90","60","72","nail","normal");
goods[438] =new setGoods("0000a57698","100","60","72","nail","normal");
goods[439] =new setGoods("0000a57699","110","60","72","nail","normal");
goods[440] =new setGoods("0000a57700","120","60","72","nail","normal");
goods[441] =new setGoods("0000a57701","130","60","72","nail","normal");
goods[442] =new setGoods("0000a57702","140","60","72","nail","normal");
goods[443] =new setGoods("0000a57703","150","60","72","nail","normal");
goods[444] =new setGoods("0000a57704","80","70","72","nail","normal");
goods[445] =new setGoods("0000a57705","90","70","72","nail","normal");
goods[446] =new setGoods("0000a57706","100","70","72","nail","normal");
goods[447] =new setGoods("0000a57707","110","70","72","nail","normal");
goods[448] =new setGoods("0000a57708","120","70","72","nail","normal");
goods[449] =new setGoods("0000a57709","130","70","72","nail","normal");
goods[450] =new setGoods("0000a57710","140","70","72","nail","normal");
goods[451] =new setGoods("0000a57711","150","70","72","nail","normal");
goods[452] =new setGoods("0000a57712","90","80","72","nail","normal");
goods[453] =new setGoods("0000a57713","100","80","72","nail","normal");
goods[454] =new setGoods("0000a57714","110","80","72","nail","normal");
goods[455] =new setGoods("0000a57715","120","80","72","nail","normal");
goods[456] =new setGoods("0000a57716","130","80","72","nail","normal");
goods[457] =new setGoods("0000a57717","140","80","72","nail","normal");
goods[458] =new setGoods("0000a57718","150","80","72","nail","normal");
goods[459] =new setGoods("0000a57719","100","90","72","nail","normal");
goods[460] =new setGoods("0000a57720","110","90","72","nail","normal");
goods[461] =new setGoods("0000a57721","120","90","72","nail","normal");
goods[462] =new setGoods("0000a57722","130","90","72","nail","normal");
goods[463] =new setGoods("0000a57723","140","90","72","nail","normal");
goods[464] =new setGoods("0000a57724","150","90","72","nail","normal");
goods[465] =new setGoods("0000a57725","40","40","72","nail","normal");
goods[466] =new setGoods("0000a57726","50","50","72","nail","normal");
goods[467] =new setGoods("0000a57727","60","60","72","nail","normal");
goods[468] =new setGoods("0000a57728","70","70","72","nail","normal");
goods[469] =new setGoods("0000a57729","80","80","72","nail","normal");
goods[470] =new setGoods("0000a57730","90","90","72","nail","normal");
goods[471] =new setGoods("0000a57731","50","40","90","nail","normal");
goods[472] =new setGoods("0000a57732","60","40","90","nail","normal");
goods[473] =new setGoods("0000a57733","70","40","90","nail","normal");
goods[474] =new setGoods("0000a57734","80","40","90","nail","normal");
goods[475] =new setGoods("0000a57735","90","40","90","nail","normal");
goods[476] =new setGoods("0000a57736","100","40","90","nail","normal");
goods[477] =new setGoods("0000a57737","110","40","90","nail","normal");
goods[478] =new setGoods("0000a57738","120","40","90","nail","normal");
goods[479] =new setGoods("0000a57739","130","40","90","nail","normal");
goods[480] =new setGoods("0000a57740","140","40","90","nail","normal");
goods[481] =new setGoods("0000a57741","150","40","90","nail","normal");
goods[482] =new setGoods("0000a57742","60","50","90","nail","normal");
goods[483] =new setGoods("0000a57743","70","50","90","nail","normal");
goods[484] =new setGoods("0000a57744","80","50","90","nail","normal");
goods[485] =new setGoods("0000a57745","90","50","90","nail","normal");
goods[486] =new setGoods("0000a57746","100","50","90","nail","normal");
goods[487] =new setGoods("0000a57747","110","50","90","nail","normal");
goods[488] =new setGoods("0000a57748","120","50","90","nail","normal");
goods[489] =new setGoods("0000a57749","130","50","90","nail","normal");
goods[490] =new setGoods("0000a57750","140","50","90","nail","normal");
goods[491] =new setGoods("0000a57751","150","50","90","nail","normal");
goods[492] =new setGoods("0000a57752","70","60","90","nail","normal");
goods[493] =new setGoods("0000a57753","80","60","90","nail","normal");
goods[494] =new setGoods("0000a57754","90","60","90","nail","normal");
goods[495] =new setGoods("0000a57755","100","60","90","nail","normal");
goods[496] =new setGoods("0000a57756","110","60","90","nail","normal");
goods[497] =new setGoods("0000a57757","120","60","90","nail","normal");
goods[498] =new setGoods("0000a57758","130","60","90","nail","normal");
goods[499] =new setGoods("0000a57759","140","60","90","nail","normal");
goods[500] =new setGoods("0000a57760","150","60","90","nail","normal");
goods[501] =new setGoods("0000a57761","80","70","90","nail","normal");
goods[502] =new setGoods("0000a57762","90","70","90","nail","normal");
goods[503] =new setGoods("0000a57763","100","70","90","nail","normal");
goods[504] =new setGoods("0000a57764","110","70","90","nail","normal");
goods[505] =new setGoods("0000a57765","120","70","90","nail","normal");
goods[506] =new setGoods("0000a57766","130","70","90","nail","normal");
goods[507] =new setGoods("0000a57767","140","70","90","nail","normal");
goods[508] =new setGoods("0000a57768","150","70","90","nail","normal");
goods[509] =new setGoods("0000a57769","90","80","90","nail","normal");
goods[510] =new setGoods("0000a57770","100","80","90","nail","normal");
goods[511] =new setGoods("0000a57771","110","80","90","nail","normal");
goods[512] =new setGoods("0000a57772","120","80","90","nail","normal");
goods[513] =new setGoods("0000a57773","130","80","90","nail","normal");
goods[514] =new setGoods("0000a57774","140","80","90","nail","normal");
goods[515] =new setGoods("0000a57775","150","80","90","nail","normal");
goods[516] =new setGoods("0000a57776","100","90","90","nail","normal");
goods[517] =new setGoods("0000a57777","110","90","90","nail","normal");
goods[518] =new setGoods("0000a57778","120","90","90","nail","normal");
goods[519] =new setGoods("0000a57779","130","90","90","nail","normal");
goods[520] =new setGoods("0000a57780","140","90","90","nail","normal");
goods[521] =new setGoods("0000a57781","150","90","90","nail","normal");
goods[522] =new setGoods("0000a57782","40","40","90","nail","normal");
goods[523] =new setGoods("0000a57783","50","50","90","nail","normal");
goods[524] =new setGoods("0000a57784","60","60","90","nail","normal");
goods[525] =new setGoods("0000a57785","70","70","90","nail","normal");
goods[526] =new setGoods("0000a57786","80","80","90","nail","normal");
goods[527] =new setGoods("0000a57787","90","90","90","nail","normal");



goods[528] =new setGoods("0000a57788","40","30","42","black","normal");
goods[529] =new setGoods("0000a57789","50","30","42","black","normal");
goods[530] =new setGoods("0000a57790","60","30","42","black","normal");
goods[531] =new setGoods("0000a57791","70","30","42","black","normal");
goods[532] =new setGoods("0000a57792","80","30","42","black","normal");
goods[533] =new setGoods("0000a57793","90","30","42","black","normal");
goods[534] =new setGoods("0000a57794","100","30","42","black","normal");
goods[535] =new setGoods("0000a57795","110","30","42","black","normal");
goods[536] =new setGoods("0000a57796","120","30","42","black","normal");
goods[537] =new setGoods("0000a57797","130","30","42","black","normal");
goods[538] =new setGoods("0000a57798","140","30","42","black","normal");
goods[539] =new setGoods("0000a57799","150","30","42","black","normal");
goods[540] =new setGoods("0000a57800","50","40","42","black","normal");
goods[541] =new setGoods("0000a57801","60","40","42","black","normal");
goods[542] =new setGoods("0000a57802","70","40","42","black","normal");
goods[543] =new setGoods("0000a57803","80","40","42","black","normal");
goods[544] =new setGoods("0000a57804","90","40","42","black","normal");
goods[545] =new setGoods("0000a57805","100","40","42","black","normal");
goods[546] =new setGoods("0000a57806","110","40","42","black","normal");
goods[547] =new setGoods("0000a57807","120","40","42","black","normal");
goods[548] =new setGoods("0000a57808","130","40","42","black","normal");
goods[549] =new setGoods("0000a57809","140","40","42","black","normal");
goods[550] =new setGoods("0000a57810","150","40","42","black","normal");
goods[551] =new setGoods("0000a57811","60","50","42","black","normal");
goods[552] =new setGoods("0000a57812","70","50","42","black","normal");
goods[553] =new setGoods("0000a57813","80","50","42","black","normal");
goods[554] =new setGoods("0000a57814","90","50","42","black","normal");
goods[555] =new setGoods("0000a57815","100","50","42","black","normal");
goods[556] =new setGoods("0000a57816","110","50","42","black","normal");
goods[557] =new setGoods("0000a57817","120","50","42","black","normal");
goods[558] =new setGoods("0000a57818","130","50","42","black","normal");
goods[559] =new setGoods("0000a57819","140","50","42","black","normal");
goods[560] =new setGoods("0000a57820","150","50","42","black","normal");
goods[561] =new setGoods("0000a57821","70","60","42","black","normal");
goods[562] =new setGoods("0000a57822","80","60","42","black","normal");
goods[563] =new setGoods("0000a57823","90","60","42","black","normal");
goods[564] =new setGoods("0000a57824","100","60","42","black","normal");
goods[565] =new setGoods("0000a57825","110","60","42","black","normal");
goods[566] =new setGoods("0000a57826","120","60","42","black","normal");
goods[567] =new setGoods("0000a57827","130","60","42","black","normal");
goods[568] =new setGoods("0000a57828","140","60","42","black","normal");
goods[569] =new setGoods("0000a57829","150","60","42","black","normal");
goods[570] =new setGoods("0000a57830","80","70","42","black","normal");
goods[571] =new setGoods("0000a57831","90","70","42","black","normal");
goods[572] =new setGoods("0000a57832","100","70","42","black","normal");
goods[573] =new setGoods("0000a57833","110","70","42","black","normal");
goods[574] =new setGoods("0000a57834","120","70","42","black","normal");
goods[575] =new setGoods("0000a57835","130","70","42","black","normal");
goods[576] =new setGoods("0000a57836","140","70","42","black","normal");
goods[577] =new setGoods("0000a57837","150","70","42","black","normal");
goods[578] =new setGoods("0000a57838","90","80","42","black","normal");
goods[579] =new setGoods("0000a57839","100","80","42","black","normal");
goods[580] =new setGoods("0000a57840","110","80","42","black","normal");
goods[581] =new setGoods("0000a57841","120","80","42","black","normal");
goods[582] =new setGoods("0000a57842","130","80","42","black","normal");
goods[583] =new setGoods("0000a57843","140","80","42","black","normal");
goods[584] =new setGoods("0000a57844","150","80","42","black","normal");
goods[585] =new setGoods("0000a57845","100","90","42","black","normal");
goods[586] =new setGoods("0000a57846","110","90","42","black","normal");
goods[587] =new setGoods("0000a57847","120","90","42","black","normal");
goods[588] =new setGoods("0000a57848","130","90","42","black","normal");
goods[589] =new setGoods("0000a57849","140","90","42","black","normal");
goods[590] =new setGoods("0000a57850","150","90","42","black","normal");
goods[591] =new setGoods("0000a57851","40","40","42","black","normal");
goods[592] =new setGoods("0000a57852","50","50","42","black","normal");
goods[593] =new setGoods("0000a57853","60","60","42","black","normal");
goods[594] =new setGoods("0000a57854","70","70","42","black","normal");
goods[595] =new setGoods("0000a57855","80","80","42","black","normal");
goods[596] =new setGoods("0000a57856","90","90","42","black","normal");
goods[597] =new setGoods("0000a57857","40","30","60","black","normal");
goods[598] =new setGoods("0000a57858","50","30","60","black","normal");
goods[599] =new setGoods("0000a57859","60","30","60","black","normal");
goods[600] =new setGoods("0000a57860","70","30","60","black","normal");
goods[601] =new setGoods("0000a57861","80","30","60","black","normal");
goods[602] =new setGoods("0000a57862","90","30","60","black","normal");
goods[603] =new setGoods("0000a57863","100","30","60","black","normal");
goods[604] =new setGoods("0000a57864","110","30","60","black","normal");
goods[605] =new setGoods("0000a57865","120","30","60","black","normal");
goods[606] =new setGoods("0000a57866","130","30","60","black","normal");
goods[607] =new setGoods("0000a57867","140","30","60","black","normal");
goods[608] =new setGoods("0000a57868","150","30","60","black","normal");
goods[609] =new setGoods("0000a57869","50","40","60","black","normal");
goods[610] =new setGoods("0000a57870","60","40","60","black","normal");
goods[611] =new setGoods("0000a57871","70","40","60","black","normal");
goods[612] =new setGoods("0000a57872","80","40","60","black","normal");
goods[613] =new setGoods("0000a57873","90","40","60","black","normal");
goods[614] =new setGoods("0000a57874","100","40","60","black","normal");
goods[615] =new setGoods("0000a57875","110","40","60","black","normal");
goods[616] =new setGoods("0000a57876","120","40","60","black","normal");
goods[617] =new setGoods("0000a57877","130","40","60","black","normal");
goods[618] =new setGoods("0000a57878","140","40","60","black","normal");
goods[619] =new setGoods("0000a57879","150","40","60","black","normal");
goods[620] =new setGoods("0000a57880","60","50","60","black","normal");
goods[621] =new setGoods("0000a57881","70","50","60","black","normal");
goods[622] =new setGoods("0000a57882","80","50","60","black","normal");
goods[623] =new setGoods("0000a57883","90","50","60","black","normal");
goods[624] =new setGoods("0000a57884","100","50","60","black","normal");
goods[625] =new setGoods("0000a57885","110","50","60","black","normal");
goods[626] =new setGoods("0000a57886","120","50","60","black","normal");
goods[627] =new setGoods("0000a57887","130","50","60","black","normal");
goods[628] =new setGoods("0000a57888","140","50","60","black","normal");
goods[629] =new setGoods("0000a57889","150","50","60","black","normal");
goods[630] =new setGoods("0000a57890","70","60","60","black","normal");
goods[631] =new setGoods("0000a57891","80","60","60","black","normal");
goods[632] =new setGoods("0000a57892","90","60","60","black","normal");
goods[633] =new setGoods("0000a57893","100","60","60","black","normal");
goods[634] =new setGoods("0000a57894","110","60","60","black","normal");
goods[635] =new setGoods("0000a57895","120","60","60","black","normal");
goods[636] =new setGoods("0000a57896","130","60","60","black","normal");
goods[637] =new setGoods("0000a57897","140","60","60","black","normal");
goods[638] =new setGoods("0000a57898","150","60","60","black","normal");
goods[639] =new setGoods("0000a57899","80","70","60","black","normal");
goods[640] =new setGoods("0000a57900","90","70","60","black","normal");
goods[641] =new setGoods("0000a57901","100","70","60","black","normal");
goods[642] =new setGoods("0000a57902","110","70","60","black","normal");
goods[643] =new setGoods("0000a57903","120","70","60","black","normal");
goods[644] =new setGoods("0000a57904","130","70","60","black","normal");
goods[645] =new setGoods("0000a57905","140","70","60","black","normal");
goods[646] =new setGoods("0000a57906","150","70","60","black","normal");
goods[647] =new setGoods("0000a57907","90","80","60","black","normal");
goods[648] =new setGoods("0000a57908","100","80","60","black","normal");
goods[649] =new setGoods("0000a57909","110","80","60","black","normal");
goods[650] =new setGoods("0000a57910","120","80","60","black","normal");
goods[651] =new setGoods("0000a57911","130","80","60","black","normal");
goods[652] =new setGoods("0000a57912","140","80","60","black","normal");
goods[653] =new setGoods("0000a57913","150","80","60","black","normal");
goods[654] =new setGoods("0000a57914","100","90","60","black","normal");
goods[655] =new setGoods("0000a57915","110","90","60","black","normal");
goods[656] =new setGoods("0000a57916","120","90","60","black","normal");
goods[657] =new setGoods("0000a57917","130","90","60","black","normal");
goods[658] =new setGoods("0000a57918","140","90","60","black","normal");
goods[659] =new setGoods("0000a57919","150","90","60","black","normal");
goods[660] =new setGoods("0000a57920","40","40","60","black","normal");
goods[661] =new setGoods("0000a57921","50","50","60","black","normal");
goods[662] =new setGoods("0000a57922","60","60","60","black","normal");
goods[663] =new setGoods("0000a57923","70","70","60","black","normal");
goods[664] =new setGoods("0000a57924","80","80","60","black","normal");
goods[665] =new setGoods("0000a57925","90","90","60","black","normal");
goods[666] =new setGoods("0000a57926","40","30","72","black","normal");
goods[667] =new setGoods("0000a57927","50","30","72","black","normal");
goods[668] =new setGoods("0000a57928","60","30","72","black","normal");
goods[669] =new setGoods("0000a57929","70","30","72","black","normal");
goods[670] =new setGoods("0000a57930","80","30","72","black","normal");
goods[671] =new setGoods("0000a57931","90","30","72","black","normal");
goods[672] =new setGoods("0000a57932","100","30","72","black","normal");
goods[673] =new setGoods("0000a57933","110","30","72","black","normal");
goods[674] =new setGoods("0000a57934","120","30","72","black","normal");
goods[675] =new setGoods("0000a57935","130","30","72","black","normal");
goods[676] =new setGoods("0000a57936","140","30","72","black","normal");
goods[677] =new setGoods("0000a57937","150","30","72","black","normal");
goods[678] =new setGoods("0000a57938","50","40","72","black","normal");
goods[679] =new setGoods("0000a57939","60","40","72","black","normal");
goods[680] =new setGoods("0000a57940","70","40","72","black","normal");
goods[681] =new setGoods("0000a57941","80","40","72","black","normal");
goods[682] =new setGoods("0000a57942","90","40","72","black","normal");
goods[683] =new setGoods("0000a57943","100","40","72","black","normal");
goods[684] =new setGoods("0000a57944","110","40","72","black","normal");
goods[685] =new setGoods("0000a57945","120","40","72","black","normal");
goods[686] =new setGoods("0000a57946","130","40","72","black","normal");
goods[687] =new setGoods("0000a57947","140","40","72","black","normal");
goods[688] =new setGoods("0000a57948","150","40","72","black","normal");
goods[689] =new setGoods("0000a57949","60","50","72","black","normal");
goods[690] =new setGoods("0000a57950","70","50","72","black","normal");
goods[691] =new setGoods("0000a57951","80","50","72","black","normal");
goods[692] =new setGoods("0000a57952","90","50","72","black","normal");
goods[693] =new setGoods("0000a57953","100","50","72","black","normal");
goods[694] =new setGoods("0000a57954","110","50","72","black","normal");
goods[695] =new setGoods("0000a57955","120","50","72","black","normal");
goods[696] =new setGoods("0000a57956","130","50","72","black","normal");
goods[697] =new setGoods("0000a57957","140","50","72","black","normal");
goods[698] =new setGoods("0000a57958","150","50","72","black","normal");
goods[699] =new setGoods("0000a57959","70","60","72","black","normal");
goods[700] =new setGoods("0000a57960","80","60","72","black","normal");
goods[701] =new setGoods("0000a57961","90","60","72","black","normal");
goods[702] =new setGoods("0000a57962","100","60","72","black","normal");
goods[703] =new setGoods("0000a57963","110","60","72","black","normal");
goods[704] =new setGoods("0000a57964","120","60","72","black","normal");
goods[705] =new setGoods("0000a57965","130","60","72","black","normal");
goods[706] =new setGoods("0000a57966","140","60","72","black","normal");
goods[707] =new setGoods("0000a57967","150","60","72","black","normal");
goods[708] =new setGoods("0000a57968","80","70","72","black","normal");
goods[709] =new setGoods("0000a57969","90","70","72","black","normal");
goods[710] =new setGoods("0000a57970","100","70","72","black","normal");
goods[711] =new setGoods("0000a57971","110","70","72","black","normal");
goods[712] =new setGoods("0000a57972","120","70","72","black","normal");
goods[713] =new setGoods("0000a57973","130","70","72","black","normal");
goods[714] =new setGoods("0000a57974","140","70","72","black","normal");
goods[715] =new setGoods("0000a57975","150","70","72","black","normal");
goods[716] =new setGoods("0000a57976","90","80","72","black","normal");
goods[717] =new setGoods("0000a57977","100","80","72","black","normal");
goods[718] =new setGoods("0000a57978","110","80","72","black","normal");
goods[719] =new setGoods("0000a57979","120","80","72","black","normal");
goods[720] =new setGoods("0000a57980","130","80","72","black","normal");
goods[721] =new setGoods("0000a57981","140","80","72","black","normal");
goods[722] =new setGoods("0000a57982","150","80","72","black","normal");
goods[723] =new setGoods("0000a57983","100","90","72","black","normal");
goods[724] =new setGoods("0000a57984","110","90","72","black","normal");
goods[725] =new setGoods("0000a57985","120","90","72","black","normal");
goods[726] =new setGoods("0000a57986","130","90","72","black","normal");
goods[727] =new setGoods("0000a57987","140","90","72","black","normal");
goods[728] =new setGoods("0000a57988","150","90","72","black","normal");
goods[729] =new setGoods("0000a57989","40","40","72","black","normal");
goods[730] =new setGoods("0000a57990","50","50","72","black","normal");
goods[731] =new setGoods("0000a57991","60","60","72","black","normal");
goods[732] =new setGoods("0000a57992","70","70","72","black","normal");
goods[733] =new setGoods("0000a57993","80","80","72","black","normal");
goods[734] =new setGoods("0000a57994","90","90","72","black","normal");
goods[735] =new setGoods("0000a57995","50","40","90","black","normal");
goods[736] =new setGoods("0000a57996","60","40","90","black","normal");
goods[737] =new setGoods("0000a57997","70","40","90","black","normal");
goods[738] =new setGoods("0000a57998","80","40","90","black","normal");
goods[739] =new setGoods("0000a57999","90","40","90","black","normal");
goods[740] =new setGoods("0000a58000","100","40","90","black","normal");
goods[741] =new setGoods("0000a58001","110","40","90","black","normal");
goods[742] =new setGoods("0000a58002","120","40","90","black","normal");
goods[743] =new setGoods("0000a58003","130","40","90","black","normal");
goods[744] =new setGoods("0000a58004","140","40","90","black","normal");
goods[745] =new setGoods("0000a58005","150","40","90","black","normal");
goods[746] =new setGoods("0000a58006","60","50","90","black","normal");
goods[747] =new setGoods("0000a58007","70","50","90","black","normal");
goods[748] =new setGoods("0000a58008","80","50","90","black","normal");
goods[749] =new setGoods("0000a58009","90","50","90","black","normal");
goods[750] =new setGoods("0000a58010","100","50","90","black","normal");
goods[751] =new setGoods("0000a58011","110","50","90","black","normal");
goods[752] =new setGoods("0000a58012","120","50","90","black","normal");
goods[753] =new setGoods("0000a58013","130","50","90","black","normal");
goods[754] =new setGoods("0000a58014","140","50","90","black","normal");
goods[755] =new setGoods("0000a58015","150","50","90","black","normal");
goods[756] =new setGoods("0000a58016","70","60","90","black","normal");
goods[757] =new setGoods("0000a58017","80","60","90","black","normal");
goods[758] =new setGoods("0000a58018","90","60","90","black","normal");
goods[759] =new setGoods("0000a58019","100","60","90","black","normal");
goods[760] =new setGoods("0000a58020","110","60","90","black","normal");
goods[761] =new setGoods("0000a58021","120","60","90","black","normal");
goods[762] =new setGoods("0000a58022","130","60","90","black","normal");
goods[763] =new setGoods("0000a58023","140","60","90","black","normal");
goods[764] =new setGoods("0000a58024","150","60","90","black","normal");
goods[765] =new setGoods("0000a58025","80","70","90","black","normal");
goods[766] =new setGoods("0000a58026","90","70","90","black","normal");
goods[767] =new setGoods("0000a58027","100","70","90","black","normal");
goods[768] =new setGoods("0000a58028","110","70","90","black","normal");
goods[769] =new setGoods("0000a58029","120","70","90","black","normal");
goods[770] =new setGoods("0000a58030","130","70","90","black","normal");
goods[771] =new setGoods("0000a58031","140","70","90","black","normal");
goods[772] =new setGoods("0000a58032","150","70","90","black","normal");
goods[773] =new setGoods("0000a58033","90","80","90","black","normal");
goods[774] =new setGoods("0000a58034","100","80","90","black","normal");
goods[775] =new setGoods("0000a58035","110","80","90","black","normal");
goods[776] =new setGoods("0000a58036","120","80","90","black","normal");
goods[777] =new setGoods("0000a58037","130","80","90","black","normal");
goods[778] =new setGoods("0000a58038","140","80","90","black","normal");
goods[779] =new setGoods("0000a58039","150","80","90","black","normal");
goods[780] =new setGoods("0000a58040","100","90","90","black","normal");
goods[781] =new setGoods("0000a58041","110","90","90","black","normal");
goods[782] =new setGoods("0000a58042","120","90","90","black","normal");
goods[783] =new setGoods("0000a58043","130","90","90","black","normal");
goods[784] =new setGoods("0000a58044","140","90","90","black","normal");
goods[785] =new setGoods("0000a58045","150","90","90","black","normal");
goods[786] =new setGoods("0000a58046","40","40","90","black","normal");
goods[787] =new setGoods("0000a58047","50","50","90","black","normal");
goods[788] =new setGoods("0000a58048","60","60","90","black","normal");
goods[789] =new setGoods("0000a58049","70","70","90","black","normal");
goods[790] =new setGoods("0000a58050","80","80","90","black","normal");
goods[791] =new setGoods("0000a58051","90","90","90","black","normal");
goods[792] =new setGoods("0000a58052","40","30","42","bp","normal");
goods[793] =new setGoods("0000a58053","50","30","42","bp","normal");
goods[794] =new setGoods("0000a58054","60","30","42","bp","normal");
goods[795] =new setGoods("0000a58055","70","30","42","bp","normal");
goods[796] =new setGoods("0000a58056","80","30","42","bp","normal");
goods[797] =new setGoods("0000a58057","90","30","42","bp","normal");
goods[798] =new setGoods("0000a58058","100","30","42","bp","normal");
goods[799] =new setGoods("0000a58059","110","30","42","bp","normal");
goods[800] =new setGoods("0000a58060","120","30","42","bp","normal");
goods[801] =new setGoods("0000a58061","130","30","42","bp","normal");
goods[802] =new setGoods("0000a58062","140","30","42","bp","normal");
goods[803] =new setGoods("0000a58063","150","30","42","bp","normal");
goods[804] =new setGoods("0000a58064","50","40","42","bp","normal");
goods[805] =new setGoods("0000a58065","60","40","42","bp","normal");
goods[806] =new setGoods("0000a58066","70","40","42","bp","normal");
goods[807] =new setGoods("0000a58067","80","40","42","bp","normal");
goods[808] =new setGoods("0000a58068","90","40","42","bp","normal");
goods[809] =new setGoods("0000a58069","100","40","42","bp","normal");
goods[810] =new setGoods("0000a58070","110","40","42","bp","normal");
goods[811] =new setGoods("0000a58071","120","40","42","bp","normal");
goods[812] =new setGoods("0000a58072","130","40","42","bp","normal");
goods[813] =new setGoods("0000a58073","140","40","42","bp","normal");
goods[814] =new setGoods("0000a58074","150","40","42","bp","normal");
goods[815] =new setGoods("0000a58075","60","50","42","bp","normal");
goods[816] =new setGoods("0000a58076","70","50","42","bp","normal");
goods[817] =new setGoods("0000a58077","80","50","42","bp","normal");
goods[818] =new setGoods("0000a58078","90","50","42","bp","normal");
goods[819] =new setGoods("0000a58079","100","50","42","bp","normal");
goods[820] =new setGoods("0000a58080","110","50","42","bp","normal");
goods[821] =new setGoods("0000a58081","120","50","42","bp","normal");
goods[822] =new setGoods("0000a58082","130","50","42","bp","normal");
goods[823] =new setGoods("0000a58083","140","50","42","bp","normal");
goods[824] =new setGoods("0000a58084","150","50","42","bp","normal");
goods[825] =new setGoods("0000a58085","70","60","42","bp","normal");
goods[826] =new setGoods("0000a58086","80","60","42","bp","normal");
goods[827] =new setGoods("0000a58087","90","60","42","bp","normal");
goods[828] =new setGoods("0000a58088","100","60","42","bp","normal");
goods[829] =new setGoods("0000a58089","110","60","42","bp","normal");
goods[830] =new setGoods("0000a58090","120","60","42","bp","normal");
goods[831] =new setGoods("0000a58091","130","60","42","bp","normal");
goods[832] =new setGoods("0000a58092","140","60","42","bp","normal");
goods[833] =new setGoods("0000a58093","150","60","42","bp","normal");
goods[834] =new setGoods("0000a58094","80","70","42","bp","normal");
goods[835] =new setGoods("0000a58095","90","70","42","bp","normal");
goods[836] =new setGoods("0000a58096","100","70","42","bp","normal");
goods[837] =new setGoods("0000a58097","110","70","42","bp","normal");
goods[838] =new setGoods("0000a58098","120","70","42","bp","normal");
goods[839] =new setGoods("0000a58099","130","70","42","bp","normal");
goods[840] =new setGoods("0000a58100","140","70","42","bp","normal");
goods[841] =new setGoods("0000a58101","150","70","42","bp","normal");
goods[842] =new setGoods("0000a58102","90","80","42","bp","normal");
goods[843] =new setGoods("0000a58103","100","80","42","bp","normal");
goods[844] =new setGoods("0000a58104","110","80","42","bp","normal");
goods[845] =new setGoods("0000a58105","120","80","42","bp","normal");
goods[846] =new setGoods("0000a58106","130","80","42","bp","normal");
goods[847] =new setGoods("0000a58107","140","80","42","bp","normal");
goods[848] =new setGoods("0000a58108","150","80","42","bp","normal");
goods[849] =new setGoods("0000a58109","100","90","42","bp","normal");
goods[850] =new setGoods("0000a58110","110","90","42","bp","normal");
goods[851] =new setGoods("0000a58111","120","90","42","bp","normal");
goods[852] =new setGoods("0000a58112","130","90","42","bp","normal");
goods[853] =new setGoods("0000a58113","140","90","42","bp","normal");
goods[854] =new setGoods("0000a58114","150","90","42","bp","normal");
goods[855] =new setGoods("0000a58115","40","40","42","bp","normal");
goods[856] =new setGoods("0000a58116","50","50","42","bp","normal");
goods[857] =new setGoods("0000a58117","60","60","42","bp","normal");
goods[858] =new setGoods("0000a58118","70","70","42","bp","normal");
goods[859] =new setGoods("0000a58119","80","80","42","bp","normal");
goods[860] =new setGoods("0000a58120","90","90","42","bp","normal");
goods[861] =new setGoods("0000a58121","40","30","60","bp","normal");
goods[862] =new setGoods("0000a58122","50","30","60","bp","normal");
goods[863] =new setGoods("0000a58123","60","30","60","bp","normal");
goods[864] =new setGoods("0000a58124","70","30","60","bp","normal");
goods[865] =new setGoods("0000a58125","80","30","60","bp","normal");
goods[866] =new setGoods("0000a58126","90","30","60","bp","normal");
goods[867] =new setGoods("0000a58127","100","30","60","bp","normal");
goods[868] =new setGoods("0000a58128","110","30","60","bp","normal");
goods[869] =new setGoods("0000a58129","120","30","60","bp","normal");
goods[870] =new setGoods("0000a58130","130","30","60","bp","normal");
goods[871] =new setGoods("0000a58131","140","30","60","bp","normal");
goods[872] =new setGoods("0000a58132","150","30","60","bp","normal");
goods[873] =new setGoods("0000a58133","50","40","60","bp","normal");
goods[874] =new setGoods("0000a58134","60","40","60","bp","normal");
goods[875] =new setGoods("0000a58135","70","40","60","bp","normal");
goods[876] =new setGoods("0000a58136","80","40","60","bp","normal");
goods[877] =new setGoods("0000a58137","90","40","60","bp","normal");
goods[878] =new setGoods("0000a58138","100","40","60","bp","normal");
goods[879] =new setGoods("0000a58139","110","40","60","bp","normal");
goods[880] =new setGoods("0000a58140","120","40","60","bp","normal");
goods[881] =new setGoods("0000a58141","130","40","60","bp","normal");
goods[882] =new setGoods("0000a58142","140","40","60","bp","normal");
goods[883] =new setGoods("0000a58143","150","40","60","bp","normal");
goods[884] =new setGoods("0000a58144","60","50","60","bp","normal");
goods[885] =new setGoods("0000a58145","70","50","60","bp","normal");
goods[886] =new setGoods("0000a58146","80","50","60","bp","normal");
goods[887] =new setGoods("0000a58147","90","50","60","bp","normal");
goods[888] =new setGoods("0000a58148","100","50","60","bp","normal");
goods[889] =new setGoods("0000a58149","110","50","60","bp","normal");
goods[890] =new setGoods("0000a58150","120","50","60","bp","normal");
goods[891] =new setGoods("0000a58151","130","50","60","bp","normal");
goods[892] =new setGoods("0000a58152","140","50","60","bp","normal");
goods[893] =new setGoods("0000a58153","150","50","60","bp","normal");
goods[894] =new setGoods("0000a58154","70","60","60","bp","normal");
goods[895] =new setGoods("0000a58155","80","60","60","bp","normal");
goods[896] =new setGoods("0000a58156","90","60","60","bp","normal");
goods[897] =new setGoods("0000a58157","100","60","60","bp","normal");
goods[898] =new setGoods("0000a58158","110","60","60","bp","normal");
goods[899] =new setGoods("0000a58159","120","60","60","bp","normal");
goods[900] =new setGoods("0000a58160","130","60","60","bp","normal");
goods[901] =new setGoods("0000a58161","140","60","60","bp","normal");
goods[902] =new setGoods("0000a58162","150","60","60","bp","normal");
goods[903] =new setGoods("0000a58163","80","70","60","bp","normal");
goods[904] =new setGoods("0000a58164","90","70","60","bp","normal");
goods[905] =new setGoods("0000a58165","100","70","60","bp","normal");
goods[906] =new setGoods("0000a58166","110","70","60","bp","normal");
goods[907] =new setGoods("0000a58167","120","70","60","bp","normal");
goods[908] =new setGoods("0000a58168","130","70","60","bp","normal");
goods[909] =new setGoods("0000a58169","140","70","60","bp","normal");
goods[910] =new setGoods("0000a58170","150","70","60","bp","normal");
goods[911] =new setGoods("0000a58171","90","80","60","bp","normal");
goods[912] =new setGoods("0000a58172","100","80","60","bp","normal");
goods[913] =new setGoods("0000a58173","110","80","60","bp","normal");
goods[914] =new setGoods("0000a58174","120","80","60","bp","normal");
goods[915] =new setGoods("0000a58175","130","80","60","bp","normal");
goods[916] =new setGoods("0000a58176","140","80","60","bp","normal");
goods[917] =new setGoods("0000a58177","150","80","60","bp","normal");
goods[918] =new setGoods("0000a58178","100","90","60","bp","normal");
goods[919] =new setGoods("0000a58179","110","90","60","bp","normal");
goods[920] =new setGoods("0000a58180","120","90","60","bp","normal");
goods[921] =new setGoods("0000a58181","130","90","60","bp","normal");
goods[922] =new setGoods("0000a58182","140","90","60","bp","normal");
goods[923] =new setGoods("0000a58183","150","90","60","bp","normal");
goods[924] =new setGoods("0000a58184","40","40","60","bp","normal");
goods[925] =new setGoods("0000a58185","50","50","60","bp","normal");
goods[926] =new setGoods("0000a58186","60","60","60","bp","normal");
goods[927] =new setGoods("0000a58187","70","70","60","bp","normal");
goods[928] =new setGoods("0000a58188","80","80","60","bp","normal");
goods[929] =new setGoods("0000a58189","90","90","60","bp","normal");
goods[930] =new setGoods("0000a58190","40","30","72","bp","normal");
goods[931] =new setGoods("0000a58191","50","30","72","bp","normal");
goods[932] =new setGoods("0000a58192","60","30","72","bp","normal");
goods[933] =new setGoods("0000a58193","70","30","72","bp","normal");
goods[934] =new setGoods("0000a58194","80","30","72","bp","normal");
goods[935] =new setGoods("0000a58195","90","30","72","bp","normal");
goods[936] =new setGoods("0000a58196","100","30","72","bp","normal");
goods[937] =new setGoods("0000a58197","110","30","72","bp","normal");
goods[938] =new setGoods("0000a58198","120","30","72","bp","normal");
goods[939] =new setGoods("0000a58199","130","30","72","bp","normal");
goods[940] =new setGoods("0000a58200","140","30","72","bp","normal");
goods[941] =new setGoods("0000a58201","150","30","72","bp","normal");
goods[942] =new setGoods("0000a58202","50","40","72","bp","normal");
goods[943] =new setGoods("0000a58203","60","40","72","bp","normal");
goods[944] =new setGoods("0000a58204","70","40","72","bp","normal");
goods[945] =new setGoods("0000a58205","80","40","72","bp","normal");
goods[946] =new setGoods("0000a58206","90","40","72","bp","normal");
goods[947] =new setGoods("0000a58207","100","40","72","bp","normal");
goods[948] =new setGoods("0000a58208","110","40","72","bp","normal");
goods[949] =new setGoods("0000a58209","120","40","72","bp","normal");
goods[950] =new setGoods("0000a58210","130","40","72","bp","normal");
goods[951] =new setGoods("0000a58211","140","40","72","bp","normal");
goods[952] =new setGoods("0000a58212","150","40","72","bp","normal");
goods[953] =new setGoods("0000a58213","60","50","72","bp","normal");
goods[954] =new setGoods("0000a58214","70","50","72","bp","normal");
goods[955] =new setGoods("0000a58215","80","50","72","bp","normal");
goods[956] =new setGoods("0000a58216","90","50","72","bp","normal");
goods[957] =new setGoods("0000a58217","100","50","72","bp","normal");
goods[958] =new setGoods("0000a58218","110","50","72","bp","normal");
goods[959] =new setGoods("0000a58219","120","50","72","bp","normal");
goods[960] =new setGoods("0000a58220","130","50","72","bp","normal");
goods[961] =new setGoods("0000a58221","140","50","72","bp","normal");
goods[962] =new setGoods("0000a58222","150","50","72","bp","normal");
goods[963] =new setGoods("0000a58223","70","60","72","bp","normal");
goods[964] =new setGoods("0000a58224","80","60","72","bp","normal");
goods[965] =new setGoods("0000a58225","90","60","72","bp","normal");
goods[966] =new setGoods("0000a58226","100","60","72","bp","normal");
goods[967] =new setGoods("0000a58227","110","60","72","bp","normal");
goods[968] =new setGoods("0000a58228","120","60","72","bp","normal");
goods[969] =new setGoods("0000a58229","130","60","72","bp","normal");
goods[970] =new setGoods("0000a58230","140","60","72","bp","normal");
goods[971] =new setGoods("0000a58231","150","60","72","bp","normal");
goods[972] =new setGoods("0000a58232","80","70","72","bp","normal");
goods[973] =new setGoods("0000a58233","90","70","72","bp","normal");
goods[974] =new setGoods("0000a58234","100","70","72","bp","normal");
goods[975] =new setGoods("0000a58235","110","70","72","bp","normal");
goods[976] =new setGoods("0000a58236","120","70","72","bp","normal");
goods[977] =new setGoods("0000a58237","130","70","72","bp","normal");
goods[978] =new setGoods("0000a58238","140","70","72","bp","normal");
goods[979] =new setGoods("0000a58239","150","70","72","bp","normal");
goods[980] =new setGoods("0000a58240","90","80","72","bp","normal");
goods[981] =new setGoods("0000a58241","100","80","72","bp","normal");
goods[982] =new setGoods("0000a58242","110","80","72","bp","normal");
goods[983] =new setGoods("0000a58243","120","80","72","bp","normal");
goods[984] =new setGoods("0000a58244","130","80","72","bp","normal");
goods[985] =new setGoods("0000a58245","140","80","72","bp","normal");
goods[986] =new setGoods("0000a58246","150","80","72","bp","normal");
goods[987] =new setGoods("0000a58247","100","90","72","bp","normal");
goods[988] =new setGoods("0000a58248","110","90","72","bp","normal");
goods[989] =new setGoods("0000a58249","120","90","72","bp","normal");
goods[990] =new setGoods("0000a58250","130","90","72","bp","normal");
goods[991] =new setGoods("0000a58251","140","90","72","bp","normal");
goods[992] =new setGoods("0000a58252","150","90","72","bp","normal");
goods[993] =new setGoods("0000a58253","40","40","72","bp","normal");
goods[994] =new setGoods("0000a58254","50","50","72","bp","normal");
goods[995] =new setGoods("0000a58255","60","60","72","bp","normal");
goods[996] =new setGoods("0000a58256","70","70","72","bp","normal");
goods[997] =new setGoods("0000a58257","80","80","72","bp","normal");
goods[998] =new setGoods("0000a58258","90","90","72","bp","normal");
goods[999] =new setGoods("0000a58259","50","40","90","bp","normal");
goods[1000] =new setGoods("0000a58260","60","40","90","bp","normal");
goods[1001] =new setGoods("0000a58261","70","40","90","bp","normal");
goods[1002] =new setGoods("0000a58262","80","40","90","bp","normal");
goods[1003] =new setGoods("0000a58263","90","40","90","bp","normal");
goods[1004] =new setGoods("0000a58264","100","40","90","bp","normal");
goods[1005] =new setGoods("0000a58265","110","40","90","bp","normal");
goods[1006] =new setGoods("0000a58266","120","40","90","bp","normal");
goods[1007] =new setGoods("0000a58267","130","40","90","bp","normal");
goods[1008] =new setGoods("0000a58268","140","40","90","bp","normal");
goods[1009] =new setGoods("0000a58269","150","40","90","bp","normal");
goods[1010] =new setGoods("0000a58270","60","50","90","bp","normal");
goods[1011] =new setGoods("0000a58271","70","50","90","bp","normal");
goods[1012] =new setGoods("0000a58272","80","50","90","bp","normal");
goods[1013] =new setGoods("0000a58273","90","50","90","bp","normal");
goods[1014] =new setGoods("0000a58274","100","50","90","bp","normal");
goods[1015] =new setGoods("0000a58275","110","50","90","bp","normal");
goods[1016] =new setGoods("0000a58276","120","50","90","bp","normal");
goods[1017] =new setGoods("0000a58277","130","50","90","bp","normal");
goods[1018] =new setGoods("0000a58278","140","50","90","bp","normal");
goods[1019] =new setGoods("0000a58279","150","50","90","bp","normal");
goods[1020] =new setGoods("0000a58280","70","60","90","bp","normal");
goods[1021] =new setGoods("0000a58281","80","60","90","bp","normal");
goods[1022] =new setGoods("0000a58282","90","60","90","bp","normal");
goods[1023] =new setGoods("0000a58283","100","60","90","bp","normal");
goods[1024] =new setGoods("0000a58284","110","60","90","bp","normal");
goods[1025] =new setGoods("0000a58285","120","60","90","bp","normal");
goods[1026] =new setGoods("0000a58286","130","60","90","bp","normal");
goods[1027] =new setGoods("0000a58287","140","60","90","bp","normal");
goods[1028] =new setGoods("0000a58288","150","60","90","bp","normal");
goods[1029] =new setGoods("0000a58289","80","70","90","bp","normal");
goods[1030] =new setGoods("0000a58290","90","70","90","bp","normal");
goods[1031] =new setGoods("0000a58291","100","70","90","bp","normal");
goods[1032] =new setGoods("0000a58292","110","70","90","bp","normal");
goods[1033] =new setGoods("0000a58293","120","70","90","bp","normal");
goods[1034] =new setGoods("0000a58294","130","70","90","bp","normal");
goods[1035] =new setGoods("0000a58295","140","70","90","bp","normal");
goods[1036] =new setGoods("0000a58296","150","70","90","bp","normal");
goods[1037] =new setGoods("0000a58297","90","80","90","bp","normal");
goods[1038] =new setGoods("0000a58298","100","80","90","bp","normal");
goods[1039] =new setGoods("0000a58299","110","80","90","bp","normal");
goods[1040] =new setGoods("0000a58300","120","80","90","bp","normal");
goods[1041] =new setGoods("0000a58301","130","80","90","bp","normal");
goods[1042] =new setGoods("0000a58302","140","80","90","bp","normal");
goods[1043] =new setGoods("0000a58303","150","80","90","bp","normal");
goods[1044] =new setGoods("0000a58304","100","90","90","bp","normal");
goods[1045] =new setGoods("0000a58305","110","90","90","bp","normal");
goods[1046] =new setGoods("0000a58306","120","90","90","bp","normal");
goods[1047] =new setGoods("0000a58307","130","90","90","bp","normal");
goods[1048] =new setGoods("0000a58308","140","90","90","bp","normal");
goods[1049] =new setGoods("0000a58309","150","90","90","bp","normal");
goods[1050] =new setGoods("0000a58310","40","40","90","bp","normal");
goods[1051] =new setGoods("0000a58311","50","50","90","bp","normal");
goods[1052] =new setGoods("0000a58312","60","60","90","bp","normal");
goods[1053] =new setGoods("0000a58313","70","70","90","bp","normal");
goods[1054] =new setGoods("0000a58314","80","80","90","bp","normal");
goods[1055] =new setGoods("0000a58315","90","90","90","bp","normal");
goods[1056] =new setGoods("0000a58580","40","30","42","gs","normal");
goods[1057] =new setGoods("0000a58581","50","30","42","gs","normal");
goods[1058] =new setGoods("0000a58582","60","30","42","gs","normal");
goods[1059] =new setGoods("0000a58583","70","30","42","gs","normal");
goods[1060] =new setGoods("0000a58584","80","30","42","gs","normal");
goods[1061] =new setGoods("0000a58585","90","30","42","gs","normal");
goods[1062] =new setGoods("0000a58586","100","30","42","gs","normal");
goods[1063] =new setGoods("0000a58587","110","30","42","gs","normal");
goods[1064] =new setGoods("0000a58588","120","30","42","gs","normal");
goods[1065] =new setGoods("0000a58589","130","30","42","gs","normal");
goods[1066] =new setGoods("0000a58590","140","30","42","gs","normal");
goods[1067] =new setGoods("0000a58591","150","30","42","gs","normal");
goods[1068] =new setGoods("0000a58592","50","40","42","gs","normal");
goods[1069] =new setGoods("0000a58593","60","40","42","gs","normal");
goods[1070] =new setGoods("0000a58594","70","40","42","gs","normal");
goods[1071] =new setGoods("0000a58595","80","40","42","gs","normal");
goods[1072] =new setGoods("0000a58596","90","40","42","gs","normal");
goods[1073] =new setGoods("0000a58597","100","40","42","gs","normal");
goods[1074] =new setGoods("0000a58598","110","40","42","gs","normal");
goods[1075] =new setGoods("0000a58599","120","40","42","gs","normal");
goods[1076] =new setGoods("0000a58600","130","40","42","gs","normal");
goods[1077] =new setGoods("0000a58601","140","40","42","gs","normal");
goods[1078] =new setGoods("0000a58602","150","40","42","gs","normal");
goods[1079] =new setGoods("0000a58603","60","50","42","gs","normal");
goods[1080] =new setGoods("0000a58604","70","50","42","gs","normal");
goods[1081] =new setGoods("0000a58605","80","50","42","gs","normal");
goods[1082] =new setGoods("0000a58606","90","50","42","gs","normal");
goods[1083] =new setGoods("0000a58607","100","50","42","gs","normal");
goods[1084] =new setGoods("0000a58608","110","50","42","gs","normal");
goods[1085] =new setGoods("0000a58609","120","50","42","gs","normal");
goods[1086] =new setGoods("0000a58610","130","50","42","gs","normal");
goods[1087] =new setGoods("0000a58611","140","50","42","gs","normal");
goods[1088] =new setGoods("0000a58612","150","50","42","gs","normal");
goods[1089] =new setGoods("0000a58613","70","60","42","gs","normal");
goods[1090] =new setGoods("0000a58614","80","60","42","gs","normal");
goods[1091] =new setGoods("0000a58615","90","60","42","gs","normal");
goods[1092] =new setGoods("0000a58616","100","60","42","gs","normal");
goods[1093] =new setGoods("0000a58617","110","60","42","gs","normal");
goods[1094] =new setGoods("0000a58618","120","60","42","gs","normal");
goods[1095] =new setGoods("0000a58619","130","60","42","gs","normal");
goods[1096] =new setGoods("0000a58620","140","60","42","gs","normal");
goods[1097] =new setGoods("0000a58621","150","60","42","gs","normal");
goods[1098] =new setGoods("0000a58622","80","70","42","gs","normal");
goods[1099] =new setGoods("0000a58623","90","70","42","gs","normal");
goods[1100] =new setGoods("0000a58624","100","70","42","gs","normal");
goods[1101] =new setGoods("0000a58625","110","70","42","gs","normal");
goods[1102] =new setGoods("0000a58626","120","70","42","gs","normal");
goods[1103] =new setGoods("0000a58627","130","70","42","gs","normal");
goods[1104] =new setGoods("0000a58628","140","70","42","gs","normal");
goods[1105] =new setGoods("0000a58629","150","70","42","gs","normal");
goods[1106] =new setGoods("0000a58630","90","80","42","gs","normal");
goods[1107] =new setGoods("0000a58631","100","80","42","gs","normal");
goods[1108] =new setGoods("0000a58632","110","80","42","gs","normal");
goods[1109] =new setGoods("0000a58633","120","80","42","gs","normal");
goods[1110] =new setGoods("0000a58634","130","80","42","gs","normal");
goods[1111] =new setGoods("0000a58635","140","80","42","gs","normal");
goods[1112] =new setGoods("0000a58636","150","80","42","gs","normal");
goods[1113] =new setGoods("0000a58637","100","90","42","gs","normal");
goods[1114] =new setGoods("0000a58638","110","90","42","gs","normal");
goods[1115] =new setGoods("0000a58639","120","90","42","gs","normal");
goods[1116] =new setGoods("0000a58640","130","90","42","gs","normal");
goods[1117] =new setGoods("0000a58641","140","90","42","gs","normal");
goods[1118] =new setGoods("0000a58642","150","90","42","gs","normal");
goods[1119] =new setGoods("0000a58643","40","40","42","gs","normal");
goods[1120] =new setGoods("0000a58644","50","50","42","gs","normal");
goods[1121] =new setGoods("0000a58645","60","60","42","gs","normal");
goods[1122] =new setGoods("0000a58646","70","70","42","gs","normal");
goods[1123] =new setGoods("0000a58647","80","80","42","gs","normal");
goods[1124] =new setGoods("0000a58648","90","90","42","gs","normal");
goods[1125] =new setGoods("0000a58649","40","30","60","gs","normal");
goods[1126] =new setGoods("0000a58650","50","30","60","gs","normal");
goods[1127] =new setGoods("0000a58651","60","30","60","gs","normal");
goods[1128] =new setGoods("0000a58652","70","30","60","gs","normal");
goods[1129] =new setGoods("0000a58653","80","30","60","gs","normal");
goods[1130] =new setGoods("0000a58654","90","30","60","gs","normal");
goods[1131] =new setGoods("0000a58655","100","30","60","gs","normal");
goods[1132] =new setGoods("0000a58656","110","30","60","gs","normal");
goods[1133] =new setGoods("0000a58657","120","30","60","gs","normal");
goods[1134] =new setGoods("0000a58658","130","30","60","gs","normal");
goods[1135] =new setGoods("0000a58659","140","30","60","gs","normal");
goods[1136] =new setGoods("0000a58660","150","30","60","gs","normal");
goods[1137] =new setGoods("0000a58661","50","40","60","gs","normal");
goods[1138] =new setGoods("0000a58662","60","40","60","gs","normal");
goods[1139] =new setGoods("0000a58663","70","40","60","gs","normal");
goods[1140] =new setGoods("0000a58664","80","40","60","gs","normal");
goods[1141] =new setGoods("0000a58665","90","40","60","gs","normal");
goods[1142] =new setGoods("0000a58666","100","40","60","gs","normal");
goods[1143] =new setGoods("0000a58667","110","40","60","gs","normal");
goods[1144] =new setGoods("0000a58668","120","40","60","gs","normal");
goods[1145] =new setGoods("0000a58669","130","40","60","gs","normal");
goods[1146] =new setGoods("0000a58670","140","40","60","gs","normal");
goods[1147] =new setGoods("0000a58671","150","40","60","gs","normal");
goods[1148] =new setGoods("0000a58672","60","50","60","gs","normal");
goods[1149] =new setGoods("0000a58673","70","50","60","gs","normal");
goods[1150] =new setGoods("0000a58674","80","50","60","gs","normal");
goods[1151] =new setGoods("0000a58675","90","50","60","gs","normal");
goods[1152] =new setGoods("0000a58676","100","50","60","gs","normal");
goods[1153] =new setGoods("0000a58677","110","50","60","gs","normal");
goods[1154] =new setGoods("0000a58678","120","50","60","gs","normal");
goods[1155] =new setGoods("0000a58679","130","50","60","gs","normal");
goods[1156] =new setGoods("0000a58680","140","50","60","gs","normal");
goods[1157] =new setGoods("0000a58681","150","50","60","gs","normal");
goods[1158] =new setGoods("0000a58682","70","60","60","gs","normal");
goods[1159] =new setGoods("0000a58683","80","60","60","gs","normal");
goods[1160] =new setGoods("0000a58684","90","60","60","gs","normal");
goods[1161] =new setGoods("0000a58685","100","60","60","gs","normal");
goods[1162] =new setGoods("0000a58686","110","60","60","gs","normal");
goods[1163] =new setGoods("0000a58687","120","60","60","gs","normal");
goods[1164] =new setGoods("0000a58688","130","60","60","gs","normal");
goods[1165] =new setGoods("0000a58689","140","60","60","gs","normal");
goods[1166] =new setGoods("0000a58690","150","60","60","gs","normal");
goods[1167] =new setGoods("0000a58691","80","70","60","gs","normal");
goods[1168] =new setGoods("0000a58692","90","70","60","gs","normal");
goods[1169] =new setGoods("0000a58693","100","70","60","gs","normal");
goods[1170] =new setGoods("0000a58694","110","70","60","gs","normal");
goods[1171] =new setGoods("0000a58695","120","70","60","gs","normal");
goods[1172] =new setGoods("0000a58696","130","70","60","gs","normal");
goods[1173] =new setGoods("0000a58697","140","70","60","gs","normal");
goods[1174] =new setGoods("0000a58698","150","70","60","gs","normal");
goods[1175] =new setGoods("0000a58699","90","80","60","gs","normal");
goods[1176] =new setGoods("0000a58700","100","80","60","gs","normal");
goods[1177] =new setGoods("0000a58701","110","80","60","gs","normal");
goods[1178] =new setGoods("0000a58702","120","80","60","gs","normal");
goods[1179] =new setGoods("0000a58703","130","80","60","gs","normal");
goods[1180] =new setGoods("0000a58704","140","80","60","gs","normal");
goods[1181] =new setGoods("0000a58705","150","80","60","gs","normal");
goods[1182] =new setGoods("0000a58706","100","90","60","gs","normal");
goods[1183] =new setGoods("0000a58707","110","90","60","gs","normal");
goods[1184] =new setGoods("0000a58708","120","90","60","gs","normal");
goods[1185] =new setGoods("0000a58709","130","90","60","gs","normal");
goods[1186] =new setGoods("0000a58710","140","90","60","gs","normal");
goods[1187] =new setGoods("0000a58711","150","90","60","gs","normal");
goods[1188] =new setGoods("0000a58712","40","40","60","gs","normal");
goods[1189] =new setGoods("0000a58713","50","50","60","gs","normal");
goods[1190] =new setGoods("0000a58714","60","60","60","gs","normal");
goods[1191] =new setGoods("0000a58715","70","70","60","gs","normal");
goods[1192] =new setGoods("0000a58716","80","80","60","gs","normal");
goods[1193] =new setGoods("0000a58717","90","90","60","gs","normal");
goods[1194] =new setGoods("0000a58718","40","30","72","gs","normal");
goods[1195] =new setGoods("0000a58719","50","30","72","gs","normal");
goods[1196] =new setGoods("0000a58720","60","30","72","gs","normal");
goods[1197] =new setGoods("0000a58721","70","30","72","gs","normal");
goods[1198] =new setGoods("0000a58722","80","30","72","gs","normal");
goods[1199] =new setGoods("0000a58723","90","30","72","gs","normal");
goods[1200] =new setGoods("0000a58724","100","30","72","gs","normal");
goods[1201] =new setGoods("0000a58725","110","30","72","gs","normal");
goods[1202] =new setGoods("0000a58726","120","30","72","gs","normal");
goods[1203] =new setGoods("0000a58727","130","30","72","gs","normal");
goods[1204] =new setGoods("0000a58728","140","30","72","gs","normal");
goods[1205] =new setGoods("0000a58729","150","30","72","gs","normal");
goods[1206] =new setGoods("0000a58730","50","40","72","gs","normal");
goods[1207] =new setGoods("0000a58731","60","40","72","gs","normal");
goods[1208] =new setGoods("0000a58732","70","40","72","gs","normal");
goods[1209] =new setGoods("0000a58733","80","40","72","gs","normal");
goods[1210] =new setGoods("0000a58734","90","40","72","gs","normal");
goods[1211] =new setGoods("0000a58735","100","40","72","gs","normal");
goods[1212] =new setGoods("0000a58736","110","40","72","gs","normal");
goods[1213] =new setGoods("0000a58737","120","40","72","gs","normal");
goods[1214] =new setGoods("0000a58738","130","40","72","gs","normal");
goods[1215] =new setGoods("0000a58739","140","40","72","gs","normal");
goods[1216] =new setGoods("0000a58740","150","40","72","gs","normal");
goods[1217] =new setGoods("0000a58741","60","50","72","gs","normal");
goods[1218] =new setGoods("0000a58742","70","50","72","gs","normal");
goods[1219] =new setGoods("0000a58743","80","50","72","gs","normal");
goods[1220] =new setGoods("0000a58744","90","50","72","gs","normal");
goods[1221] =new setGoods("0000a58745","100","50","72","gs","normal");
goods[1222] =new setGoods("0000a58746","110","50","72","gs","normal");
goods[1223] =new setGoods("0000a58747","120","50","72","gs","normal");
goods[1224] =new setGoods("0000a58748","130","50","72","gs","normal");
goods[1225] =new setGoods("0000a58749","140","50","72","gs","normal");
goods[1226] =new setGoods("0000a58750","150","50","72","gs","normal");
goods[1227] =new setGoods("0000a58751","70","60","72","gs","normal");
goods[1228] =new setGoods("0000a58752","80","60","72","gs","normal");
goods[1229] =new setGoods("0000a58753","90","60","72","gs","normal");
goods[1230] =new setGoods("0000a58754","100","60","72","gs","normal");
goods[1231] =new setGoods("0000a58755","110","60","72","gs","normal");
goods[1232] =new setGoods("0000a58756","120","60","72","gs","normal");
goods[1233] =new setGoods("0000a58757","130","60","72","gs","normal");
goods[1234] =new setGoods("0000a58758","140","60","72","gs","normal");
goods[1235] =new setGoods("0000a58759","150","60","72","gs","normal");
goods[1236] =new setGoods("0000a58760","80","70","72","gs","normal");
goods[1237] =new setGoods("0000a58761","90","70","72","gs","normal");
goods[1238] =new setGoods("0000a58762","100","70","72","gs","normal");
goods[1239] =new setGoods("0000a58763","110","70","72","gs","normal");
goods[1240] =new setGoods("0000a58764","120","70","72","gs","normal");
goods[1241] =new setGoods("0000a58765","130","70","72","gs","normal");
goods[1242] =new setGoods("0000a58766","140","70","72","gs","normal");
goods[1243] =new setGoods("0000a58767","150","70","72","gs","normal");
goods[1244] =new setGoods("0000a58768","90","80","72","gs","normal");
goods[1245] =new setGoods("0000a58769","100","80","72","gs","normal");
goods[1246] =new setGoods("0000a58770","110","80","72","gs","normal");
goods[1247] =new setGoods("0000a58771","120","80","72","gs","normal");
goods[1248] =new setGoods("0000a58772","130","80","72","gs","normal");
goods[1249] =new setGoods("0000a58773","140","80","72","gs","normal");
goods[1250] =new setGoods("0000a58774","150","80","72","gs","normal");
goods[1251] =new setGoods("0000a58775","100","90","72","gs","normal");
goods[1252] =new setGoods("0000a58776","110","90","72","gs","normal");
goods[1253] =new setGoods("0000a58777","120","90","72","gs","normal");
goods[1254] =new setGoods("0000a58778","130","90","72","gs","normal");
goods[1255] =new setGoods("0000a58779","140","90","72","gs","normal");
goods[1256] =new setGoods("0000a58780","150","90","72","gs","normal");
goods[1257] =new setGoods("0000a58781","40","40","72","gs","normal");
goods[1258] =new setGoods("0000a58782","50","50","72","gs","normal");
goods[1259] =new setGoods("0000a58783","60","60","72","gs","normal");
goods[1260] =new setGoods("0000a58784","70","70","72","gs","normal");
goods[1261] =new setGoods("0000a58785","80","80","72","gs","normal");
goods[1262] =new setGoods("0000a58786","90","90","72","gs","normal");
goods[1263] =new setGoods("0000a58787","50","40","90","gs","normal");
goods[1264] =new setGoods("0000a58788","60","40","90","gs","normal");
goods[1265] =new setGoods("0000a58789","70","40","90","gs","normal");
goods[1266] =new setGoods("0000a58790","80","40","90","gs","normal");
goods[1267] =new setGoods("0000a58791","90","40","90","gs","normal");
goods[1268] =new setGoods("0000a58792","100","40","90","gs","normal");
goods[1269] =new setGoods("0000a58793","110","40","90","gs","normal");
goods[1270] =new setGoods("0000a58794","120","40","90","gs","normal");
goods[1271] =new setGoods("0000a58795","130","40","90","gs","normal");
goods[1272] =new setGoods("0000a58796","140","40","90","gs","normal");
goods[1273] =new setGoods("0000a58797","150","40","90","gs","normal");
goods[1274] =new setGoods("0000a58798","60","50","90","gs","normal");
goods[1275] =new setGoods("0000a58799","70","50","90","gs","normal");
goods[1276] =new setGoods("0000a58800","80","50","90","gs","normal");
goods[1277] =new setGoods("0000a58801","90","50","90","gs","normal");
goods[1278] =new setGoods("0000a58802","100","50","90","gs","normal");
goods[1279] =new setGoods("0000a58803","110","50","90","gs","normal");
goods[1280] =new setGoods("0000a58804","120","50","90","gs","normal");
goods[1281] =new setGoods("0000a58805","130","50","90","gs","normal");
goods[1282] =new setGoods("0000a58806","140","50","90","gs","normal");
goods[1283] =new setGoods("0000a58807","150","50","90","gs","normal");
goods[1284] =new setGoods("0000a58808","70","60","90","gs","normal");
goods[1285] =new setGoods("0000a58809","80","60","90","gs","normal");
goods[1286] =new setGoods("0000a58810","90","60","90","gs","normal");
goods[1287] =new setGoods("0000a58811","100","60","90","gs","normal");
goods[1288] =new setGoods("0000a58812","110","60","90","gs","normal");
goods[1289] =new setGoods("0000a58813","120","60","90","gs","normal");
goods[1290] =new setGoods("0000a58814","130","60","90","gs","normal");
goods[1291] =new setGoods("0000a58815","140","60","90","gs","normal");
goods[1292] =new setGoods("0000a58816","150","60","90","gs","normal");
goods[1293] =new setGoods("0000a58817","80","70","90","gs","normal");
goods[1294] =new setGoods("0000a58818","90","70","90","gs","normal");
goods[1295] =new setGoods("0000a58819","100","70","90","gs","normal");
goods[1296] =new setGoods("0000a58820","110","70","90","gs","normal");
goods[1297] =new setGoods("0000a58821","120","70","90","gs","normal");
goods[1298] =new setGoods("0000a58822","130","70","90","gs","normal");
goods[1299] =new setGoods("0000a58823","140","70","90","gs","normal");
goods[1300] =new setGoods("0000a58824","150","70","90","gs","normal");
goods[1301] =new setGoods("0000a58825","90","80","90","gs","normal");
goods[1302] =new setGoods("0000a58826","100","80","90","gs","normal");
goods[1303] =new setGoods("0000a58827","110","80","90","gs","normal");
goods[1304] =new setGoods("0000a58828","120","80","90","gs","normal");
goods[1305] =new setGoods("0000a58829","130","80","90","gs","normal");
goods[1306] =new setGoods("0000a58830","140","80","90","gs","normal");
goods[1307] =new setGoods("0000a58831","150","80","90","gs","normal");
goods[1308] =new setGoods("0000a58832","100","90","90","gs","normal");
goods[1309] =new setGoods("0000a58833","110","90","90","gs","normal");
goods[1310] =new setGoods("0000a58834","120","90","90","gs","normal");
goods[1311] =new setGoods("0000a58835","130","90","90","gs","normal");
goods[1312] =new setGoods("0000a58836","140","90","90","gs","normal");
goods[1313] =new setGoods("0000a58837","150","90","90","gs","normal");
goods[1314] =new setGoods("0000a58838","40","40","90","gs","normal");
goods[1315] =new setGoods("0000a58839","50","50","90","gs","normal");
goods[1316] =new setGoods("0000a58840","60","60","90","gs","normal");
goods[1317] =new setGoods("0000a58841","70","70","90","gs","normal");
goods[1318] =new setGoods("0000a58842","80","80","90","gs","normal");
goods[1319] =new setGoods("0000a58843","90","90","90","gs","normal");
goods[1320] =new setGoods("0000a58844","40","30","42","ww","normal");
goods[1321] =new setGoods("0000a58845","50","30","42","ww","normal");
goods[1322] =new setGoods("0000a58846","60","30","42","ww","normal");
goods[1323] =new setGoods("0000a58847","70","30","42","ww","normal");
goods[1324] =new setGoods("0000a58848","80","30","42","ww","normal");
goods[1325] =new setGoods("0000a58849","90","30","42","ww","normal");
goods[1326] =new setGoods("0000a58850","100","30","42","ww","normal");
goods[1327] =new setGoods("0000a58851","110","30","42","ww","normal");
goods[1328] =new setGoods("0000a58852","120","30","42","ww","normal");
goods[1329] =new setGoods("0000a58853","130","30","42","ww","normal");
goods[1330] =new setGoods("0000a58854","140","30","42","ww","normal");
goods[1331] =new setGoods("0000a58855","150","30","42","ww","normal");
goods[1332] =new setGoods("0000a58856","50","40","42","ww","normal");
goods[1333] =new setGoods("0000a58857","60","40","42","ww","normal");
goods[1334] =new setGoods("0000a58858","70","40","42","ww","normal");
goods[1335] =new setGoods("0000a58859","80","40","42","ww","normal");
goods[1336] =new setGoods("0000a58860","90","40","42","ww","normal");
goods[1337] =new setGoods("0000a58861","100","40","42","ww","normal");
goods[1338] =new setGoods("0000a58862","110","40","42","ww","normal");
goods[1339] =new setGoods("0000a58863","120","40","42","ww","normal");
goods[1340] =new setGoods("0000a58864","130","40","42","ww","normal");
goods[1341] =new setGoods("0000a58865","140","40","42","ww","normal");
goods[1342] =new setGoods("0000a58866","150","40","42","ww","normal");
goods[1343] =new setGoods("0000a58867","60","50","42","ww","normal");
goods[1344] =new setGoods("0000a58868","70","50","42","ww","normal");
goods[1345] =new setGoods("0000a58869","80","50","42","ww","normal");
goods[1346] =new setGoods("0000a58870","90","50","42","ww","normal");
goods[1347] =new setGoods("0000a58871","100","50","42","ww","normal");
goods[1348] =new setGoods("0000a58872","110","50","42","ww","normal");
goods[1349] =new setGoods("0000a58873","120","50","42","ww","normal");
goods[1350] =new setGoods("0000a58874","130","50","42","ww","normal");
goods[1351] =new setGoods("0000a58875","140","50","42","ww","normal");
goods[1352] =new setGoods("0000a58876","150","50","42","ww","normal");
goods[1353] =new setGoods("0000a58877","70","60","42","ww","normal");
goods[1354] =new setGoods("0000a58878","80","60","42","ww","normal");
goods[1355] =new setGoods("0000a58879","90","60","42","ww","normal");
goods[1356] =new setGoods("0000a58880","100","60","42","ww","normal");
goods[1357] =new setGoods("0000a58881","110","60","42","ww","normal");
goods[1358] =new setGoods("0000a58882","120","60","42","ww","normal");
goods[1359] =new setGoods("0000a58883","130","60","42","ww","normal");
goods[1360] =new setGoods("0000a58884","140","60","42","ww","normal");
goods[1361] =new setGoods("0000a58885","150","60","42","ww","normal");
goods[1362] =new setGoods("0000a58886","80","70","42","ww","normal");
goods[1363] =new setGoods("0000a58887","90","70","42","ww","normal");
goods[1364] =new setGoods("0000a58888","100","70","42","ww","normal");
goods[1365] =new setGoods("0000a58889","110","70","42","ww","normal");
goods[1366] =new setGoods("0000a58890","120","70","42","ww","normal");
goods[1367] =new setGoods("0000a58891","130","70","42","ww","normal");
goods[1368] =new setGoods("0000a58892","140","70","42","ww","normal");
goods[1369] =new setGoods("0000a58893","150","70","42","ww","normal");
goods[1370] =new setGoods("0000a58894","90","80","42","ww","normal");
goods[1371] =new setGoods("0000a58895","100","80","42","ww","normal");
goods[1372] =new setGoods("0000a58896","110","80","42","ww","normal");
goods[1373] =new setGoods("0000a58897","120","80","42","ww","normal");
goods[1374] =new setGoods("0000a58898","130","80","42","ww","normal");
goods[1375] =new setGoods("0000a58899","140","80","42","ww","normal");
goods[1376] =new setGoods("0000a58900","150","80","42","ww","normal");
goods[1377] =new setGoods("0000a58901","100","90","42","ww","normal");
goods[1378] =new setGoods("0000a58902","110","90","42","ww","normal");
goods[1379] =new setGoods("0000a58903","120","90","42","ww","normal");
goods[1380] =new setGoods("0000a58904","130","90","42","ww","normal");
goods[1381] =new setGoods("0000a58905","140","90","42","ww","normal");
goods[1382] =new setGoods("0000a58906","150","90","42","ww","normal");
goods[1383] =new setGoods("0000a58907","40","40","42","ww","normal");
goods[1384] =new setGoods("0000a58908","50","50","42","ww","normal");
goods[1385] =new setGoods("0000a58909","60","60","42","ww","normal");
goods[1386] =new setGoods("0000a58910","70","70","42","ww","normal");
goods[1387] =new setGoods("0000a58911","80","80","42","ww","normal");
goods[1388] =new setGoods("0000a58912","90","90","42","ww","normal");
goods[1389] =new setGoods("0000a58913","40","30","60","ww","normal");
goods[1390] =new setGoods("0000a58914","50","30","60","ww","normal");
goods[1391] =new setGoods("0000a58915","60","30","60","ww","normal");
goods[1392] =new setGoods("0000a58916","70","30","60","ww","normal");
goods[1393] =new setGoods("0000a58917","80","30","60","ww","normal");
goods[1394] =new setGoods("0000a58918","90","30","60","ww","normal");
goods[1395] =new setGoods("0000a58919","100","30","60","ww","normal");
goods[1396] =new setGoods("0000a58920","110","30","60","ww","normal");
goods[1397] =new setGoods("0000a58921","120","30","60","ww","normal");
goods[1398] =new setGoods("0000a58922","130","30","60","ww","normal");
goods[1399] =new setGoods("0000a58923","140","30","60","ww","normal");
goods[1400] =new setGoods("0000a58924","150","30","60","ww","normal");
goods[1401] =new setGoods("0000a58925","50","40","60","ww","normal");
goods[1402] =new setGoods("0000a58926","60","40","60","ww","normal");
goods[1403] =new setGoods("0000a58927","70","40","60","ww","normal");
goods[1404] =new setGoods("0000a58928","80","40","60","ww","normal");
goods[1405] =new setGoods("0000a58929","90","40","60","ww","normal");
goods[1406] =new setGoods("0000a58930","100","40","60","ww","normal");
goods[1407] =new setGoods("0000a58931","110","40","60","ww","normal");
goods[1408] =new setGoods("0000a58932","120","40","60","ww","normal");
goods[1409] =new setGoods("0000a58933","130","40","60","ww","normal");
goods[1410] =new setGoods("0000a58934","140","40","60","ww","normal");
goods[1411] =new setGoods("0000a58935","150","40","60","ww","normal");
goods[1412] =new setGoods("0000a58936","60","50","60","ww","normal");
goods[1413] =new setGoods("0000a58937","70","50","60","ww","normal");
goods[1414] =new setGoods("0000a58938","80","50","60","ww","normal");
goods[1415] =new setGoods("0000a58939","90","50","60","ww","normal");
goods[1416] =new setGoods("0000a58940","100","50","60","ww","normal");
goods[1417] =new setGoods("0000a58941","110","50","60","ww","normal");
goods[1418] =new setGoods("0000a58942","120","50","60","ww","normal");
goods[1419] =new setGoods("0000a58943","130","50","60","ww","normal");
goods[1420] =new setGoods("0000a58944","140","50","60","ww","normal");
goods[1421] =new setGoods("0000a58945","150","50","60","ww","normal");
goods[1422] =new setGoods("0000a58946","70","60","60","ww","normal");
goods[1423] =new setGoods("0000a58947","80","60","60","ww","normal");
goods[1424] =new setGoods("0000a58948","90","60","60","ww","normal");
goods[1425] =new setGoods("0000a58949","100","60","60","ww","normal");
goods[1426] =new setGoods("0000a58950","110","60","60","ww","normal");
goods[1427] =new setGoods("0000a58951","120","60","60","ww","normal");
goods[1428] =new setGoods("0000a58952","130","60","60","ww","normal");
goods[1429] =new setGoods("0000a58953","140","60","60","ww","normal");
goods[1430] =new setGoods("0000a58954","150","60","60","ww","normal");
goods[1431] =new setGoods("0000a58955","80","70","60","ww","normal");
goods[1432] =new setGoods("0000a58956","90","70","60","ww","normal");
goods[1433] =new setGoods("0000a58957","100","70","60","ww","normal");
goods[1434] =new setGoods("0000a58958","110","70","60","ww","normal");
goods[1435] =new setGoods("0000a58959","120","70","60","ww","normal");
goods[1436] =new setGoods("0000a58960","130","70","60","ww","normal");
goods[1437] =new setGoods("0000a58961","140","70","60","ww","normal");
goods[1438] =new setGoods("0000a58962","150","70","60","ww","normal");
goods[1439] =new setGoods("0000a58963","90","80","60","ww","normal");
goods[1440] =new setGoods("0000a58964","100","80","60","ww","normal");
goods[1441] =new setGoods("0000a58965","110","80","60","ww","normal");
goods[1442] =new setGoods("0000a58966","120","80","60","ww","normal");
goods[1443] =new setGoods("0000a58967","130","80","60","ww","normal");
goods[1444] =new setGoods("0000a58968","140","80","60","ww","normal");
goods[1445] =new setGoods("0000a58969","150","80","60","ww","normal");
goods[1446] =new setGoods("0000a58970","100","90","60","ww","normal");
goods[1447] =new setGoods("0000a58971","110","90","60","ww","normal");
goods[1448] =new setGoods("0000a58972","120","90","60","ww","normal");
goods[1449] =new setGoods("0000a58973","130","90","60","ww","normal");
goods[1450] =new setGoods("0000a58974","140","90","60","ww","normal");
goods[1451] =new setGoods("0000a58975","150","90","60","ww","normal");
goods[1452] =new setGoods("0000a58976","40","40","60","ww","normal");
goods[1453] =new setGoods("0000a58977","50","50","60","ww","normal");
goods[1454] =new setGoods("0000a58978","60","60","60","ww","normal");
goods[1455] =new setGoods("0000a58979","70","70","60","ww","normal");
goods[1456] =new setGoods("0000a58980","80","80","60","ww","normal");
goods[1457] =new setGoods("0000a58981","90","90","60","ww","normal");
goods[1458] =new setGoods("0000a58982","40","30","72","ww","normal");
goods[1459] =new setGoods("0000a58983","50","30","72","ww","normal");
goods[1460] =new setGoods("0000a58984","60","30","72","ww","normal");
goods[1461] =new setGoods("0000a58985","70","30","72","ww","normal");
goods[1462] =new setGoods("0000a58986","80","30","72","ww","normal");
goods[1463] =new setGoods("0000a58987","90","30","72","ww","normal");
goods[1464] =new setGoods("0000a58988","100","30","72","ww","normal");
goods[1465] =new setGoods("0000a58989","110","30","72","ww","normal");
goods[1466] =new setGoods("0000a58990","120","30","72","ww","normal");
goods[1467] =new setGoods("0000a58991","130","30","72","ww","normal");
goods[1468] =new setGoods("0000a58992","140","30","72","ww","normal");
goods[1469] =new setGoods("0000a58993","150","30","72","ww","normal");
goods[1470] =new setGoods("0000a58994","50","40","72","ww","normal");
goods[1471] =new setGoods("0000a58995","60","40","72","ww","normal");
goods[1472] =new setGoods("0000a58996","70","40","72","ww","normal");
goods[1473] =new setGoods("0000a58997","80","40","72","ww","normal");
goods[1474] =new setGoods("0000a58998","90","40","72","ww","normal");
goods[1475] =new setGoods("0000a58999","100","40","72","ww","normal");
goods[1476] =new setGoods("0000a59000","110","40","72","ww","normal");
goods[1477] =new setGoods("0000a59001","120","40","72","ww","normal");
goods[1478] =new setGoods("0000a59002","130","40","72","ww","normal");
goods[1479] =new setGoods("0000a59003","140","40","72","ww","normal");
goods[1480] =new setGoods("0000a59004","150","40","72","ww","normal");
goods[1481] =new setGoods("0000a59005","60","50","72","ww","normal");
goods[1482] =new setGoods("0000a59006","70","50","72","ww","normal");
goods[1483] =new setGoods("0000a59007","80","50","72","ww","normal");
goods[1484] =new setGoods("0000a59008","90","50","72","ww","normal");
goods[1485] =new setGoods("0000a59009","100","50","72","ww","normal");
goods[1486] =new setGoods("0000a59010","110","50","72","ww","normal");
goods[1487] =new setGoods("0000a59011","120","50","72","ww","normal");
goods[1488] =new setGoods("0000a59012","130","50","72","ww","normal");
goods[1489] =new setGoods("0000a59013","140","50","72","ww","normal");
goods[1490] =new setGoods("0000a59014","150","50","72","ww","normal");
goods[1491] =new setGoods("0000a59015","70","60","72","ww","normal");
goods[1492] =new setGoods("0000a59016","80","60","72","ww","normal");
goods[1493] =new setGoods("0000a59017","90","60","72","ww","normal");
goods[1494] =new setGoods("0000a59018","100","60","72","ww","normal");
goods[1495] =new setGoods("0000a59019","110","60","72","ww","normal");
goods[1496] =new setGoods("0000a59020","120","60","72","ww","normal");
goods[1497] =new setGoods("0000a59021","130","60","72","ww","normal");
goods[1498] =new setGoods("0000a59022","140","60","72","ww","normal");
goods[1499] =new setGoods("0000a59023","150","60","72","ww","normal");
goods[1500] =new setGoods("0000a59024","80","70","72","ww","normal");
goods[1501] =new setGoods("0000a59025","90","70","72","ww","normal");
goods[1502] =new setGoods("0000a59026","100","70","72","ww","normal");
goods[1503] =new setGoods("0000a59027","110","70","72","ww","normal");
goods[1504] =new setGoods("0000a59028","120","70","72","ww","normal");
goods[1505] =new setGoods("0000a59029","130","70","72","ww","normal");
goods[1506] =new setGoods("0000a59030","140","70","72","ww","normal");
goods[1507] =new setGoods("0000a59031","150","70","72","ww","normal");
goods[1508] =new setGoods("0000a59032","90","80","72","ww","normal");
goods[1509] =new setGoods("0000a59033","100","80","72","ww","normal");
goods[1510] =new setGoods("0000a59034","110","80","72","ww","normal");
goods[1511] =new setGoods("0000a59035","120","80","72","ww","normal");
goods[1512] =new setGoods("0000a59036","130","80","72","ww","normal");
goods[1513] =new setGoods("0000a59037","140","80","72","ww","normal");
goods[1514] =new setGoods("0000a59038","150","80","72","ww","normal");
goods[1515] =new setGoods("0000a59039","100","90","72","ww","normal");
goods[1516] =new setGoods("0000a59040","110","90","72","ww","normal");
goods[1517] =new setGoods("0000a59041","120","90","72","ww","normal");
goods[1518] =new setGoods("0000a59042","130","90","72","ww","normal");
goods[1519] =new setGoods("0000a59043","140","90","72","ww","normal");
goods[1520] =new setGoods("0000a59044","150","90","72","ww","normal");
goods[1521] =new setGoods("0000a59045","40","40","72","ww","normal");
goods[1522] =new setGoods("0000a59046","50","50","72","ww","normal");
goods[1523] =new setGoods("0000a59047","60","60","72","ww","normal");
goods[1524] =new setGoods("0000a59048","70","70","72","ww","normal");
goods[1525] =new setGoods("0000a59049","80","80","72","ww","normal");
goods[1526] =new setGoods("0000a59050","90","90","72","ww","normal");
goods[1527] =new setGoods("0000a59051","50","40","90","ww","normal");
goods[1528] =new setGoods("0000a59052","60","40","90","ww","normal");
goods[1529] =new setGoods("0000a59053","70","40","90","ww","normal");
goods[1530] =new setGoods("0000a59054","80","40","90","ww","normal");
goods[1531] =new setGoods("0000a59055","90","40","90","ww","normal");
goods[1532] =new setGoods("0000a59056","100","40","90","ww","normal");
goods[1533] =new setGoods("0000a59057","110","40","90","ww","normal");
goods[1534] =new setGoods("0000a59058","120","40","90","ww","normal");
goods[1535] =new setGoods("0000a59059","130","40","90","ww","normal");
goods[1536] =new setGoods("0000a59060","140","40","90","ww","normal");
goods[1537] =new setGoods("0000a59061","150","40","90","ww","normal");
goods[1538] =new setGoods("0000a59062","60","50","90","ww","normal");
goods[1539] =new setGoods("0000a59063","70","50","90","ww","normal");
goods[1540] =new setGoods("0000a59064","80","50","90","ww","normal");
goods[1541] =new setGoods("0000a59065","90","50","90","ww","normal");
goods[1542] =new setGoods("0000a59066","100","50","90","ww","normal");
goods[1543] =new setGoods("0000a59067","110","50","90","ww","normal");
goods[1544] =new setGoods("0000a59068","120","50","90","ww","normal");
goods[1545] =new setGoods("0000a59069","130","50","90","ww","normal");
goods[1546] =new setGoods("0000a59070","140","50","90","ww","normal");
goods[1547] =new setGoods("0000a59071","150","50","90","ww","normal");
goods[1548] =new setGoods("0000a59072","70","60","90","ww","normal");
goods[1549] =new setGoods("0000a59073","80","60","90","ww","normal");
goods[1550] =new setGoods("0000a59074","90","60","90","ww","normal");
goods[1551] =new setGoods("0000a59075","100","60","90","ww","normal");
goods[1552] =new setGoods("0000a59076","110","60","90","ww","normal");
goods[1553] =new setGoods("0000a59077","120","60","90","ww","normal");
goods[1554] =new setGoods("0000a59078","130","60","90","ww","normal");
goods[1555] =new setGoods("0000a59079","140","60","90","ww","normal");
goods[1556] =new setGoods("0000a59080","150","60","90","ww","normal");
goods[1557] =new setGoods("0000a59081","80","70","90","ww","normal");
goods[1558] =new setGoods("0000a59082","90","70","90","ww","normal");
goods[1559] =new setGoods("0000a59083","100","70","90","ww","normal");
goods[1560] =new setGoods("0000a59084","110","70","90","ww","normal");
goods[1561] =new setGoods("0000a59085","120","70","90","ww","normal");
goods[1562] =new setGoods("0000a59086","130","70","90","ww","normal");
goods[1563] =new setGoods("0000a59087","140","70","90","ww","normal");
goods[1564] =new setGoods("0000a59088","150","70","90","ww","normal");
goods[1565] =new setGoods("0000a59089","90","80","90","ww","normal");
goods[1566] =new setGoods("0000a59090","100","80","90","ww","normal");
goods[1567] =new setGoods("0000a59091","110","80","90","ww","normal");
goods[1568] =new setGoods("0000a59092","120","80","90","ww","normal");
goods[1569] =new setGoods("0000a59093","130","80","90","ww","normal");
goods[1570] =new setGoods("0000a59094","140","80","90","ww","normal");
goods[1571] =new setGoods("0000a59095","150","80","90","ww","normal");
goods[1572] =new setGoods("0000a59096","100","90","90","ww","normal");
goods[1573] =new setGoods("0000a59097","110","90","90","ww","normal");
goods[1574] =new setGoods("0000a59098","120","90","90","ww","normal");
goods[1575] =new setGoods("0000a59099","130","90","90","ww","normal");
goods[1576] =new setGoods("0000a59100","140","90","90","ww","normal");
goods[1577] =new setGoods("0000a59101","150","90","90","ww","normal");
goods[1578] =new setGoods("0000a59102","40","40","90","ww","normal");
goods[1579] =new setGoods("0000a59103","50","50","90","ww","normal");
goods[1580] =new setGoods("0000a59104","60","60","90","ww","normal");
goods[1581] =new setGoods("0000a59105","70","70","90","ww","normal");
goods[1582] =new setGoods("0000a59106","80","80","90","ww","normal");
goods[1583] =new setGoods("0000a59107","90","90","90","ww","normal");
goods[1584] =new setGoods("0000a58316","40","30","42","mb","normal");
goods[1585] =new setGoods("0000a58317","50","30","42","mb","normal");
goods[1586] =new setGoods("0000a58318","60","30","42","mb","normal");
goods[1587] =new setGoods("0000a58319","70","30","42","mb","normal");
goods[1588] =new setGoods("0000a58320","80","30","42","mb","normal");
goods[1589] =new setGoods("0000a58321","90","30","42","mb","normal");
goods[1590] =new setGoods("0000a58322","100","30","42","mb","normal");
goods[1591] =new setGoods("0000a58323","110","30","42","mb","normal");
goods[1592] =new setGoods("0000a58324","120","30","42","mb","normal");
goods[1593] =new setGoods("0000a58325","130","30","42","mb","normal");
goods[1594] =new setGoods("0000a58326","140","30","42","mb","normal");
goods[1595] =new setGoods("0000a58327","150","30","42","mb","normal");
goods[1596] =new setGoods("0000a58328","50","40","42","mb","normal");
goods[1597] =new setGoods("0000a58329","60","40","42","mb","normal");
goods[1598] =new setGoods("0000a58330","70","40","42","mb","normal");
goods[1599] =new setGoods("0000a58331","80","40","42","mb","normal");
goods[1600] =new setGoods("0000a58332","90","40","42","mb","normal");
goods[1601] =new setGoods("0000a58333","100","40","42","mb","normal");
goods[1602] =new setGoods("0000a58334","110","40","42","mb","normal");
goods[1603] =new setGoods("0000a58335","120","40","42","mb","normal");
goods[1604] =new setGoods("0000a58336","130","40","42","mb","normal");
goods[1605] =new setGoods("0000a58337","140","40","42","mb","normal");
goods[1606] =new setGoods("0000a58338","150","40","42","mb","normal");
goods[1607] =new setGoods("0000a58339","60","50","42","mb","normal");
goods[1608] =new setGoods("0000a58340","70","50","42","mb","normal");
goods[1609] =new setGoods("0000a58341","80","50","42","mb","normal");
goods[1610] =new setGoods("0000a58342","90","50","42","mb","normal");
goods[1611] =new setGoods("0000a58343","100","50","42","mb","normal");
goods[1612] =new setGoods("0000a58344","110","50","42","mb","normal");
goods[1613] =new setGoods("0000a58345","120","50","42","mb","normal");
goods[1614] =new setGoods("0000a58346","130","50","42","mb","normal");
goods[1615] =new setGoods("0000a58347","140","50","42","mb","normal");
goods[1616] =new setGoods("0000a58348","150","50","42","mb","normal");
goods[1617] =new setGoods("0000a58349","70","60","42","mb","normal");
goods[1618] =new setGoods("0000a58350","80","60","42","mb","normal");
goods[1619] =new setGoods("0000a58351","90","60","42","mb","normal");
goods[1620] =new setGoods("0000a58352","100","60","42","mb","normal");
goods[1621] =new setGoods("0000a58353","110","60","42","mb","normal");
goods[1622] =new setGoods("0000a58354","120","60","42","mb","normal");
goods[1623] =new setGoods("0000a58355","130","60","42","mb","normal");
goods[1624] =new setGoods("0000a58356","140","60","42","mb","normal");
goods[1625] =new setGoods("0000a58357","150","60","42","mb","normal");
goods[1626] =new setGoods("0000a58358","80","70","42","mb","normal");
goods[1627] =new setGoods("0000a58359","90","70","42","mb","normal");
goods[1628] =new setGoods("0000a58360","100","70","42","mb","normal");
goods[1629] =new setGoods("0000a58361","110","70","42","mb","normal");
goods[1630] =new setGoods("0000a58362","120","70","42","mb","normal");
goods[1631] =new setGoods("0000a58363","130","70","42","mb","normal");
goods[1632] =new setGoods("0000a58364","140","70","42","mb","normal");
goods[1633] =new setGoods("0000a58365","150","70","42","mb","normal");
goods[1634] =new setGoods("0000a58366","90","80","42","mb","normal");
goods[1635] =new setGoods("0000a58367","100","80","42","mb","normal");
goods[1636] =new setGoods("0000a58368","110","80","42","mb","normal");
goods[1637] =new setGoods("0000a58369","120","80","42","mb","normal");
goods[1638] =new setGoods("0000a58370","130","80","42","mb","normal");
goods[1639] =new setGoods("0000a58371","140","80","42","mb","normal");
goods[1640] =new setGoods("0000a58372","150","80","42","mb","normal");
goods[1641] =new setGoods("0000a58373","100","90","42","mb","normal");
goods[1642] =new setGoods("0000a58374","110","90","42","mb","normal");
goods[1643] =new setGoods("0000a58375","120","90","42","mb","normal");
goods[1644] =new setGoods("0000a58376","130","90","42","mb","normal");
goods[1645] =new setGoods("0000a58377","140","90","42","mb","normal");
goods[1646] =new setGoods("0000a58378","150","90","42","mb","normal");
goods[1647] =new setGoods("0000a58379","40","40","42","mb","normal");
goods[1648] =new setGoods("0000a58380","50","50","42","mb","normal");
goods[1649] =new setGoods("0000a58381","60","60","42","mb","normal");
goods[1650] =new setGoods("0000a58382","70","70","42","mb","normal");
goods[1651] =new setGoods("0000a58383","80","80","42","mb","normal");
goods[1652] =new setGoods("0000a58384","90","90","42","mb","normal");
goods[1653] =new setGoods("0000a58385","40","30","60","mb","normal");
goods[1654] =new setGoods("0000a58386","50","30","60","mb","normal");
goods[1655] =new setGoods("0000a58387","60","30","60","mb","normal");
goods[1656] =new setGoods("0000a58388","70","30","60","mb","normal");
goods[1657] =new setGoods("0000a58389","80","30","60","mb","normal");
goods[1658] =new setGoods("0000a58390","90","30","60","mb","normal");
goods[1659] =new setGoods("0000a58391","100","30","60","mb","normal");
goods[1660] =new setGoods("0000a58392","110","30","60","mb","normal");
goods[1661] =new setGoods("0000a58393","120","30","60","mb","normal");
goods[1662] =new setGoods("0000a58394","130","30","60","mb","normal");
goods[1663] =new setGoods("0000a58395","140","30","60","mb","normal");
goods[1664] =new setGoods("0000a58396","150","30","60","mb","normal");
goods[1665] =new setGoods("0000a58397","50","40","60","mb","normal");
goods[1666] =new setGoods("0000a58398","60","40","60","mb","normal");
goods[1667] =new setGoods("0000a58399","70","40","60","mb","normal");
goods[1668] =new setGoods("0000a58400","80","40","60","mb","normal");
goods[1669] =new setGoods("0000a58401","90","40","60","mb","normal");
goods[1670] =new setGoods("0000a58402","100","40","60","mb","normal");
goods[1671] =new setGoods("0000a58403","110","40","60","mb","normal");
goods[1672] =new setGoods("0000a58404","120","40","60","mb","normal");
goods[1673] =new setGoods("0000a58405","130","40","60","mb","normal");
goods[1674] =new setGoods("0000a58406","140","40","60","mb","normal");
goods[1675] =new setGoods("0000a58407","150","40","60","mb","normal");
goods[1676] =new setGoods("0000a58408","60","50","60","mb","normal");
goods[1677] =new setGoods("0000a58409","70","50","60","mb","normal");
goods[1678] =new setGoods("0000a58410","80","50","60","mb","normal");
goods[1679] =new setGoods("0000a58411","90","50","60","mb","normal");
goods[1680] =new setGoods("0000a58412","100","50","60","mb","normal");
goods[1681] =new setGoods("0000a58413","110","50","60","mb","normal");
goods[1682] =new setGoods("0000a58414","120","50","60","mb","normal");
goods[1683] =new setGoods("0000a58415","130","50","60","mb","normal");
goods[1684] =new setGoods("0000a58416","140","50","60","mb","normal");
goods[1685] =new setGoods("0000a58417","150","50","60","mb","normal");
goods[1686] =new setGoods("0000a58418","70","60","60","mb","normal");
goods[1687] =new setGoods("0000a58419","80","60","60","mb","normal");
goods[1688] =new setGoods("0000a58420","90","60","60","mb","normal");
goods[1689] =new setGoods("0000a58421","100","60","60","mb","normal");
goods[1690] =new setGoods("0000a58422","110","60","60","mb","normal");
goods[1691] =new setGoods("0000a58423","120","60","60","mb","normal");
goods[1692] =new setGoods("0000a58424","130","60","60","mb","normal");
goods[1693] =new setGoods("0000a58425","140","60","60","mb","normal");
goods[1694] =new setGoods("0000a58426","150","60","60","mb","normal");
goods[1695] =new setGoods("0000a58427","80","70","60","mb","normal");
goods[1696] =new setGoods("0000a58428","90","70","60","mb","normal");
goods[1697] =new setGoods("0000a58429","100","70","60","mb","normal");
goods[1698] =new setGoods("0000a58430","110","70","60","mb","normal");
goods[1699] =new setGoods("0000a58431","120","70","60","mb","normal");
goods[1700] =new setGoods("0000a58432","130","70","60","mb","normal");
goods[1701] =new setGoods("0000a58433","140","70","60","mb","normal");
goods[1702] =new setGoods("0000a58434","150","70","60","mb","normal");
goods[1703] =new setGoods("0000a58435","90","80","60","mb","normal");
goods[1704] =new setGoods("0000a58436","100","80","60","mb","normal");
goods[1705] =new setGoods("0000a58437","110","80","60","mb","normal");
goods[1706] =new setGoods("0000a58438","120","80","60","mb","normal");
goods[1707] =new setGoods("0000a58439","130","80","60","mb","normal");
goods[1708] =new setGoods("0000a58440","140","80","60","mb","normal");
goods[1709] =new setGoods("0000a58441","150","80","60","mb","normal");
goods[1710] =new setGoods("0000a58442","100","90","60","mb","normal");
goods[1711] =new setGoods("0000a58443","110","90","60","mb","normal");
goods[1712] =new setGoods("0000a58444","120","90","60","mb","normal");
goods[1713] =new setGoods("0000a58445","130","90","60","mb","normal");
goods[1714] =new setGoods("0000a58446","140","90","60","mb","normal");
goods[1715] =new setGoods("0000a58447","150","90","60","mb","normal");
goods[1716] =new setGoods("0000a58448","40","40","60","mb","normal");
goods[1717] =new setGoods("0000a58449","50","50","60","mb","normal");
goods[1718] =new setGoods("0000a58450","60","60","60","mb","normal");
goods[1719] =new setGoods("0000a58451","70","70","60","mb","normal");
goods[1720] =new setGoods("0000a58452","80","80","60","mb","normal");
goods[1721] =new setGoods("0000a58453","90","90","60","mb","normal");
goods[1722] =new setGoods("0000a58454","40","30","72","mb","normal");
goods[1723] =new setGoods("0000a58455","50","30","72","mb","normal");
goods[1724] =new setGoods("0000a58456","60","30","72","mb","normal");
goods[1725] =new setGoods("0000a58457","70","30","72","mb","normal");
goods[1726] =new setGoods("0000a58458","80","30","72","mb","normal");
goods[1727] =new setGoods("0000a58459","90","30","72","mb","normal");
goods[1728] =new setGoods("0000a58460","100","30","72","mb","normal");
goods[1729] =new setGoods("0000a58461","110","30","72","mb","normal");
goods[1730] =new setGoods("0000a58462","120","30","72","mb","normal");
goods[1731] =new setGoods("0000a58463","130","30","72","mb","normal");
goods[1732] =new setGoods("0000a58464","140","30","72","mb","normal");
goods[1733] =new setGoods("0000a58465","150","30","72","mb","normal");
goods[1734] =new setGoods("0000a58466","50","40","72","mb","normal");
goods[1735] =new setGoods("0000a58467","60","40","72","mb","normal");
goods[1736] =new setGoods("0000a58468","70","40","72","mb","normal");
goods[1737] =new setGoods("0000a58469","80","40","72","mb","normal");
goods[1738] =new setGoods("0000a58470","90","40","72","mb","normal");
goods[1739] =new setGoods("0000a58471","100","40","72","mb","normal");
goods[1740] =new setGoods("0000a58472","110","40","72","mb","normal");
goods[1741] =new setGoods("0000a58473","120","40","72","mb","normal");
goods[1742] =new setGoods("0000a58474","130","40","72","mb","normal");
goods[1743] =new setGoods("0000a58475","140","40","72","mb","normal");
goods[1744] =new setGoods("0000a58476","150","40","72","mb","normal");
goods[1745] =new setGoods("0000a58477","60","50","72","mb","normal");
goods[1746] =new setGoods("0000a58478","70","50","72","mb","normal");
goods[1747] =new setGoods("0000a58479","80","50","72","mb","normal");
goods[1748] =new setGoods("0000a58480","90","50","72","mb","normal");
goods[1749] =new setGoods("0000a58481","100","50","72","mb","normal");
goods[1750] =new setGoods("0000a58482","110","50","72","mb","normal");
goods[1751] =new setGoods("0000a58483","120","50","72","mb","normal");
goods[1752] =new setGoods("0000a58484","130","50","72","mb","normal");
goods[1753] =new setGoods("0000a58485","140","50","72","mb","normal");
goods[1754] =new setGoods("0000a58486","150","50","72","mb","normal");
goods[1755] =new setGoods("0000a58487","70","60","72","mb","normal");
goods[1756] =new setGoods("0000a58488","80","60","72","mb","normal");
goods[1757] =new setGoods("0000a58489","90","60","72","mb","normal");
goods[1758] =new setGoods("0000a58490","100","60","72","mb","normal");
goods[1759] =new setGoods("0000a58491","110","60","72","mb","normal");
goods[1760] =new setGoods("0000a58492","120","60","72","mb","normal");
goods[1761] =new setGoods("0000a58493","130","60","72","mb","normal");
goods[1762] =new setGoods("0000a58494","140","60","72","mb","normal");
goods[1763] =new setGoods("0000a58495","150","60","72","mb","normal");
goods[1764] =new setGoods("0000a58496","80","70","72","mb","normal");
goods[1765] =new setGoods("0000a58497","90","70","72","mb","normal");
goods[1766] =new setGoods("0000a58498","100","70","72","mb","normal");
goods[1767] =new setGoods("0000a58499","110","70","72","mb","normal");
goods[1768] =new setGoods("0000a58500","120","70","72","mb","normal");
goods[1769] =new setGoods("0000a58501","130","70","72","mb","normal");
goods[1770] =new setGoods("0000a58502","140","70","72","mb","normal");
goods[1771] =new setGoods("0000a58503","150","70","72","mb","normal");
goods[1772] =new setGoods("0000a58504","90","80","72","mb","normal");
goods[1773] =new setGoods("0000a58505","100","80","72","mb","normal");
goods[1774] =new setGoods("0000a58506","110","80","72","mb","normal");
goods[1775] =new setGoods("0000a58507","120","80","72","mb","normal");
goods[1776] =new setGoods("0000a58508","130","80","72","mb","normal");
goods[1777] =new setGoods("0000a58509","140","80","72","mb","normal");
goods[1778] =new setGoods("0000a58510","150","80","72","mb","normal");
goods[1779] =new setGoods("0000a58511","100","90","72","mb","normal");
goods[1780] =new setGoods("0000a58512","110","90","72","mb","normal");
goods[1781] =new setGoods("0000a58513","120","90","72","mb","normal");
goods[1782] =new setGoods("0000a58514","130","90","72","mb","normal");
goods[1783] =new setGoods("0000a58515","140","90","72","mb","normal");
goods[1784] =new setGoods("0000a58516","150","90","72","mb","normal");
goods[1785] =new setGoods("0000a58517","40","40","72","mb","normal");
goods[1786] =new setGoods("0000a58518","50","50","72","mb","normal");
goods[1787] =new setGoods("0000a58519","60","60","72","mb","normal");
goods[1788] =new setGoods("0000a58520","70","70","72","mb","normal");
goods[1789] =new setGoods("0000a58521","80","80","72","mb","normal");
goods[1790] =new setGoods("0000a58522","90","90","72","mb","normal");
goods[1791] =new setGoods("0000a58523","50","40","90","mb","normal");
goods[1792] =new setGoods("0000a58524","60","40","90","mb","normal");
goods[1793] =new setGoods("0000a58525","70","40","90","mb","normal");
goods[1794] =new setGoods("0000a58526","80","40","90","mb","normal");
goods[1795] =new setGoods("0000a58527","90","40","90","mb","normal");
goods[1796] =new setGoods("0000a58528","100","40","90","mb","normal");
goods[1797] =new setGoods("0000a58529","110","40","90","mb","normal");
goods[1798] =new setGoods("0000a58530","120","40","90","mb","normal");
goods[1799] =new setGoods("0000a58531","130","40","90","mb","normal");
goods[1800] =new setGoods("0000a58532","140","40","90","mb","normal");
goods[1801] =new setGoods("0000a58533","150","40","90","mb","normal");
goods[1802] =new setGoods("0000a58534","60","50","90","mb","normal");
goods[1803] =new setGoods("0000a58535","70","50","90","mb","normal");
goods[1804] =new setGoods("0000a58536","80","50","90","mb","normal");
goods[1805] =new setGoods("0000a58537","90","50","90","mb","normal");
goods[1806] =new setGoods("0000a58538","100","50","90","mb","normal");
goods[1807] =new setGoods("0000a58539","110","50","90","mb","normal");
goods[1808] =new setGoods("0000a58540","120","50","90","mb","normal");
goods[1809] =new setGoods("0000a58541","130","50","90","mb","normal");
goods[1810] =new setGoods("0000a58542","140","50","90","mb","normal");
goods[1811] =new setGoods("0000a58543","150","50","90","mb","normal");
goods[1812] =new setGoods("0000a58544","70","60","90","mb","normal");
goods[1813] =new setGoods("0000a58545","80","60","90","mb","normal");
goods[1814] =new setGoods("0000a58546","90","60","90","mb","normal");
goods[1815] =new setGoods("0000a58547","100","60","90","mb","normal");
goods[1816] =new setGoods("0000a58548","110","60","90","mb","normal");
goods[1817] =new setGoods("0000a58549","120","60","90","mb","normal");
goods[1818] =new setGoods("0000a58550","130","60","90","mb","normal");
goods[1819] =new setGoods("0000a58551","140","60","90","mb","normal");
goods[1820] =new setGoods("0000a58552","150","60","90","mb","normal");
goods[1821] =new setGoods("0000a58553","80","70","90","mb","normal");
goods[1822] =new setGoods("0000a58554","90","70","90","mb","normal");
goods[1823] =new setGoods("0000a58555","100","70","90","mb","normal");
goods[1824] =new setGoods("0000a58556","110","70","90","mb","normal");
goods[1825] =new setGoods("0000a58557","120","70","90","mb","normal");
goods[1826] =new setGoods("0000a58558","130","70","90","mb","normal");
goods[1827] =new setGoods("0000a58559","140","70","90","mb","normal");
goods[1828] =new setGoods("0000a58560","150","70","90","mb","normal");
goods[1829] =new setGoods("0000a58561","90","80","90","mb","normal");
goods[1830] =new setGoods("0000a58562","100","80","90","mb","normal");
goods[1831] =new setGoods("0000a58563","110","80","90","mb","normal");
goods[1832] =new setGoods("0000a58564","120","80","90","mb","normal");
goods[1833] =new setGoods("0000a58565","130","80","90","mb","normal");
goods[1834] =new setGoods("0000a58566","140","80","90","mb","normal");
goods[1835] =new setGoods("0000a58567","150","80","90","mb","normal");
goods[1836] =new setGoods("0000a58568","100","90","90","mb","normal");
goods[1837] =new setGoods("0000a58569","110","90","90","mb","normal");
goods[1838] =new setGoods("0000a58570","120","90","90","mb","normal");
goods[1839] =new setGoods("0000a58571","130","90","90","mb","normal");
goods[1840] =new setGoods("0000a58572","140","90","90","mb","normal");
goods[1841] =new setGoods("0000a58573","150","90","90","mb","normal");
goods[1842] =new setGoods("0000a58574","40","40","90","mb","normal");
goods[1843] =new setGoods("0000a58575","50","50","90","mb","normal");
goods[1844] =new setGoods("0000a58576","60","60","90","mb","normal");
goods[1845] =new setGoods("0000a58577","70","70","90","mb","normal");
goods[1846] =new setGoods("0000a58578","80","80","90","mb","normal");
goods[1847] =new setGoods("0000a58579","90","90","90","mb","normal");


